// register split text
gsap.registerPlugin(ScrollTrigger, SplitText)

// global selectors
const body = document.body
const select = (e) => document.querySelector(e)
const selectAll = (e) => document.querySelectorAll(e)
const selectId = (id) => document.getElementById(id)
const vh = (coef) => window.innerHeight * (coef/100)
const vw = (coef) => window.innerWidth * (coef/100)

let lenis

// cookies
function setCookie(name, value, days) {
    const date = new Date()
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
    const expires = 'expires=' + date.toUTCString()
    document.cookie = name + '=' + value + ';' + expires + ';path=/'
}

function getCookie(name) {
    const nameEQ = name + '='
    const ca = document.cookie.split(';')
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) == ' ') c = c.substring(1, c.length)
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
    }
    return null
}

// init all click, mouseover and keyup functions
function initClickAndKeyFunctions() {

	// make anchor links scroll smoothy
	$('.sliding-link').click(function(e) {
		e.preventDefault()
		var aid = $(this).attr('href')
		$('html, body').animate({ scrollTop: $(aid).offset().top }, 1000)
	})

	$(document).on('click', '.yotpo.bottomLine.top-review-stars', function(e) {
		e.preventDefault();
		$(this).addClass('sliding-link');
	
		var aid = '#reviews';
		$('html, body').animate({ scrollTop: $(aid).offset().top }, 1000);
	});
	

	// show / hide password
	$('.show-pass').click(function(e){
		e.preventDefault()
		var that = $(this)
		that.toggleClass('hidden')	

		setTimeout(function() {
			if (that.hasClass('hidden')){
				that.siblings('input').attr('type','text')
			} else {
				that.siblings('input').attr('type','password')
			}
		}, 30)
	})

	// correct label click
	$('label').click(function(e){
		e.stopImmediatePropagation()
	})

	// open / close fs menu
	$('.open-fs').click(function(){

		var tl = gsap.timeline()

		tl.to('body', {
			overflow: 'hidden',
			duration: 0
		})

		tl.to('#fs-menu', {
			display: 'block',
			duration: 0
		})

		tl.to('.blur-everything', {
			opacity: 1,
			pointerEvents: 'auto',
			duration: .3
		})

		tl.to('#fs-menu', {
			transform: 'none',
			duration: .3
		}, '-=.3s')

		tl.call(function() {
			lenis.stop()
		})

	})

	// close fs
	function closeFs() {

		var tl = gsap.timeline()

		tl.to('body', {
			overflow: 'auto',
			duration: 0
		})

		tl.to('.blur-everything', {
			opacity: 0,
			pointerEvents: 'none',
			duration: .3
		})

		tl.to('#fs-menu', {
			transform: 'translateX(-150%)',
			duration: .3
		}, '-=.3s')

		tl.to('.blur-everything', {
			pointerEvents: 'none',
			duration: 0
		})

		tl.call(function() {
			lenis.start()
		})
	}

	// close fs menu
	$('.close-fs, #fs-menu .menu a, #fs-menu .menu button, .blur-everything').click(function(){
		closeFs()
	})

	// Flag to prevent duplicate form submissions
	let isAddingToCart = false;

	// open / close cart menu
	$('.open-cart').click(function(e){
		
		// Check if this button is inside a product form
		const $form = $(this).closest('form[action*="/cart/add"]');
		
		if ($form.length > 0) {
			e.preventDefault(); // Prevent default form submission
			
			// Prevent duplicate submissions
		if (isAddingToCart) {
			return false;
		}
			
		isAddingToCart = true;
			
			// Submit the form via AJAX
			$.ajax({
				type: 'POST',
				url: '/cart/add',
				data: $form.serialize(),
				success: function(response) {
					isAddingToCart = false;
					// Now open the cart
					openCart();
				},
				error: function(error) {
					isAddingToCart = false;
				}
			});
		} else {
			// Not a product form button, just open cart
			openCart();
		}

		var tl = gsap.timeline()

		tl.to('body', {
			overflow: 'hidden',
			duration: 0
		})

		tl.to('#cart-menu', {
			display: 'block',
			duration: 0
		})

		tl.to('.blur-everything', {
			opacity: 1,
			pointerEvents: 'auto',
			duration: .3
		})

		tl.to('#cart-menu', {
			transform: 'none',
			duration: .3
		}, '-=.3s')

		tl.call(function() {
			lenis.stop()
		})

	})

	// close cart
	function closeCart() {

		var tl = gsap.timeline()

		tl.to('body', {
			overflow: 'auto',
			duration: 0
		})

		tl.to('.blur-everything', {
			opacity: 0,
			pointerEvents: 'none',
			duration: .3
		})

		tl.to('#cart-menu', {
			transform: 'translateX(150%)',
			duration: .3
		}, '-=.3s')

		tl.to('.blur-everything', {
			pointerEvents: 'none',
			duration: 0
		})

		tl.call(function() {
			lenis.start()
		})
	}

	// close cart menu
	$('.close-cart, .blur-everything').click(function(){
		closeCart()
	})

	// close all opened menus when pressing the ESC key
	$(document).keyup(function(e) {
		if(e.key === 'Escape') {
			closeFs()
			closeCart()
		}
	})

	// accordion open / close
	$('.accordion .question').click(function(){
		$(this).toggleClass('active')
		$(this).siblings('.answer').slideToggle(function(){
			//ScrollTrigger.refresh()
		})
	})

	// open 360 viewer
	$('.open-360').click(function(){
		var productId = $(this).data('productid');
		init360(productId)
	})
}

// here goes all the scroll related animations
function scrollTriggerAnimations() {

	// bg video fade
	if($('.bg-video').length) {
		gsap.to('.bg-video .overlay', {
			ease: 'none',
			opacity: 1,
			scrollTrigger: {
				trigger: '#banner',
				endTrigger: '#quem-somos',
				scrub: 3,
				start: '10% top',
				end: 'bottom 20%'
			}
		})

		gsap.to('.bg-video video', {
			scale: 2,
			rotation: -10,
			scrollTrigger: {
				trigger: '#banner',
				endTrigger: '#quem-somos',
				scrub: 3,
				start: '10% top',
				end: 'bottom 20%'
			}
		})
	}

	// fill title
	if($('.fill-title').length) {

		const title = new SplitText('.fill-title', { type: 'lines' })

		title.lines.forEach((target) => {
			gsap.to(target, {
				backgroundPositionX: 0,
				ease: 'none',
				scrollTrigger: {
					trigger: target,
					scrub: 3,
					start: 'top 90%',
					end: 'top 60%'
				}
			})
		})
	}

	// reveal text
	if($('.reveal-text').length) {

        const texts = selectAll('.reveal-text')
    
        texts.forEach(text => {
            
            // reset if needed
            if(text.anim) {
                text.anim.progress(1).kill()
            	text.split.revert()
            }

            text.split = new SplitText(text, { 
                type: 'lines, words, chars',
                linesClass: 'split-line'
            })

            // set up the anim
            text.anim = gsap.from(text.split.chars, {
                scrollTrigger: {
                    trigger: text,
                    start: 'top 80%'
                },
                duration: .75,
                ease: 'circ.out', 
                y: '100%',
				autoAlpha: 0, 
                stagger: 0.0375
            })
        })

	}

	// video box
	if($('.video-box').length) {
		gsap.to('.video-box .bg', {
			ease: 'none',
			width: '100%',
			height: '100%',
			scrollTrigger: {
				trigger: '.video-box',
				scrub: 2,
				start: 'top 80%',
				end: 'bottom 90%'
			}
		})

		gsap.to('.video-box .bottle', {
			ease: 'none',
			transform: 'none',
			scrollTrigger: {
				trigger: '.video-box',
				scrub: 2,
				start: 'top 80%',
				end: 'bottom 90%'
			}
		})

		gsap.to('.video-box .texts .line', {
			ease: 'none',
			width: '3rem',
			scrollTrigger: {
				trigger: '.video-box',
				scrub: 2,
				start: 'top 80%',
				end: 'bottom 90%'
			}
		})

		gsap.to('.video-box .texts p', {
			ease: 'none',
			opacity: 1,
			scrollTrigger: {
				trigger: '.video-box',
				scrub: 2,
				start: 'top 80%',
				end: 'bottom 90%'
			}
		})
	}

	// scrolling image / video
	if($('.scrolling-bg').length) {

		const bg = selectAll('.scrolling-bg')
    
        bg.forEach(item => {
			let calcSize = 'calc(100% + 7rem)'
			let size = '-7rem'
			const children = item.querySelector('.bg')

			gsap.set(children, {
				height: calcSize
			})

			gsap.from(children, {
				y: size,
				scrollTrigger: {
					trigger: item,
					scrub: 2,
					end: 'bottom top',
					//markers: true
				}
			})

		})
	}

	// image reveal animation
	if($('.image-reveal')) {

		const imageReveal = $('.image-reveal')
	
		imageReveal.each(function() {
			const reveal = $(this).find('.reveal')
			const image = $(this).find('img')
	
			const timeline = gsap.timeline({
				paused: true
			})
	
			timeline.set(image, {
				scale: 1.5
			})
	
			timeline.to(reveal, {
				width: '100%',
				ease: Power4.easeInOut,
				duration: 0.75
			})
	
			timeline.to(reveal, {
				x: '102%',
				ease: Power4.easeIn,
				duration: 1.0
			})
	
			timeline.to(image, {
				visibility: 'visible',
				scale: 1,
				duration: 2.5,
				ease: Power4.easeOut
			}, '=-1')
	
			ScrollTrigger.create({
				trigger: this,
				start: '0% 100%',
				end: '100% 0%',
				onEnter: () => timeline.play(),
				onLeaveBack: () => timeline.reverse()
			})
		})
	}

	// stagger fadeInUp effect
	if(select('.stagger-children')) {

		gsap.set('.stagger-children > *', {
			autoAlpha: 0,
			y: '3rem',
		})

		ScrollTrigger.batch('.stagger-children > *', {
			start: '0 97%',
			onEnter: elements => {
			  	gsap.to(elements, {
					autoAlpha: 1,
					y: '=-3rem',
					stagger: 0.15,
					duration: 1
			  	});
			},
			onLeaveBack: elements => {
				gsap.to(elements, {
					autoAlpha: 0,
					y: '3rem',
					stagger: 0.15,
					duration: 1,
				})
			}
		})
	}

	// floating buy button / homepage
	if($('.floating-button').length) {
		gsap.fromTo('.floating-button', {
			autoAlpha: 0,
			y: 100
		}, {
			autoAlpha: 1,
			y: 0,
			duration: 1,
			ease: Power2.easeIn
		})

		ScrollTrigger.create({
			trigger: '#products-section',
			start: '0% 100%',
			end: '100% 0%',
			onEnter: () => (
				gsap.to('.floating-button', {
					autoAlpha: 0,
					y: -20,
					duration: .3,
					ease: Power1.easeOut
				})
			),
			onLeaveBack: () => (
				gsap.to('.floating-button', {
					autoAlpha: 1,
					y: 0,
					duration: .3,
					ease: Power1.easeIn
				})
			)
		})
	}

	// marquee effect
	if(select('.marquee-slider')) {

		const scrollingText = gsap.utils.toArray('.marquee-slider-wrapper > span')

		const tl = horizontalLoop(scrollingText, {
			repeat: -1
		})

		Observer.create({
			onChangeY(self) {
				let factor = 1.25

				if (self.deltaY < 0) {
					factor *= -1
				}

				gsap.timeline({
					defaults: {
						ease: 'none',
					}
				})

				.to(tl, { timeScale: factor * 1.75, duration: .2 })
				.to(tl, { timeScale: factor / 1.75, duration: 1 }, '+=0.3')
			}
		})

		function horizontalLoop(items, config) {
			items = gsap.utils.toArray(items)
			config = config || {}

			let tl = gsap.timeline({
					repeat: config.repeat,
					paused: config.paused,
					defaults: { ease: 'none' },
					onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)
				}),
				length = items.length,
				startX = items[0].offsetLeft,
				times = [],
				widths = [],
				xPercents = [],
				curIndex = 0,
				pixelsPerSecond = (config.speed || 1) * 100,
				snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1),
				totalWidth, curX, distanceToStart, distanceToLoop, item, i

			gsap.set(items, {
				xPercent: (i, el) => {
					let w = widths[i] = parseFloat(gsap.getProperty(el, 'width', 'px'))
					xPercents[i] = snap(parseFloat(gsap.getProperty(el, 'x', 'px')) / w * 100 + gsap.getProperty(el, 'xPercent'))
					return xPercents[i]
				}
			})

			gsap.set(items, {x: 0})
			totalWidth = items[length - 1].offsetLeft + xPercents[length - 1] / 100 * widths[length - 1] - startX + items[length - 1].offsetWidth * gsap.getProperty(items[length - 1], 'scaleX') + (parseFloat(config.paddingRight) || 0)

			for (i = 0; i < length; i++) {
				item = items[i]
				curX = xPercents[i] / 100 * widths[i]
				distanceToStart = item.offsetLeft + curX - startX
				distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, 'scaleX')
				tl.to(item, {xPercent: snap((curX - distanceToLoop) / widths[i] * 100), duration: distanceToLoop / pixelsPerSecond}, 0)
					.fromTo(item, {xPercent: snap((curX - distanceToLoop + totalWidth) / widths[i] * 100)}, {xPercent: xPercents[i], duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond, immediateRender: false}, distanceToLoop / pixelsPerSecond)
					.add('label' + i, distanceToStart / pixelsPerSecond)
				times[i] = distanceToStart / pixelsPerSecond
			}

			function toIndex(index, vars) {
				vars = vars || {}
				(Math.abs(index - curIndex) > length / 2) && (index += index > curIndex ? -length : length)
				let newIndex = gsap.utils.wrap(0, length, index),
					time = times[newIndex]
				if (time > tl.time() !== index > curIndex) {
					vars.modifiers = {time: gsap.utils.wrap(0, tl.duration())}
					time += tl.duration() * (index > curIndex ? 1 : -1)
				}
				curIndex = newIndex
				vars.overwrite = true
				return tl.tweenTo(time, vars)
			}

			tl.next = vars => toIndex(curIndex + 1, vars)
			tl.previous = vars => toIndex(curIndex - 1, vars)
			tl.current = () => curIndex
			tl.toIndex = (index, vars) => toIndex(index, vars)
			tl.times = times
			tl.progress(1, true).progress(0, true)

			if (config.reversed) {
				tl.vars.onReverseComplete()
				tl.reverse()
			}

			return tl
		}
	}
}

// init fancybox
function initFancybox() {
	Fancybox.bind('[data-fancybox]', {
		autoFocus: false,
		dragToClose: false,
		placeFocusBack: false,
		on: {
			ready: () => {
				lenis.stop()
			},
			close: () => {
				lenis.start()
			}
		}
	})

	Fancybox.bind('[data-fancybox="360"]', {
		autoFocus: false,
		dragToClose: false,
		mainClass: 'view-360',
		placeFocusBack: false,
		on: {
			ready: () => {
				lenis.stop()
			},
			close: () => {
				lenis.start()
			}
		}
	})
}

// init 360 product viewer
function init360(productId) {

	var spriteslider = document.createElement('div')
	document.body.appendChild(spriteslider)
	spriteslider.slider = document.getElementById('product-360')
	spriteslider.imageElement = document.getElementById('target')

	// number of images
	spriteslider.imageCount = 20

	// pixels to drag per image update
	spriteslider.pixelsperincrement = 10

	// values used by the image changer
	spriteslider.multiplier = spriteslider.lastmultiplier = 0

	// array to store preloaded images
	spriteslider.preloadedImages = []

	// function to preload images with logging
	function preloadImages() {
		for (var i = 0; i < spriteslider.imageCount; i++) {
			var img = new Image()
			var imageNumber = String(i).padStart(2, '0')
			img.src = 'https://cdn.shopify.com/s/files/1/0611/8290/2314/files/' + productId + '_' + imageNumber + '.png'
			spriteslider.preloadedImages.push(img)
		}
	}

	// call the preload function
	preloadImages()

	Draggable.create(spriteslider, {
		type: 'x',
		trigger: spriteslider.slider,
		edgeResistance: 0,
		cursor: 'e-resize',
		throwProps: true,
		onDrag: function() {
			if (this.isDragging) {
				var t = this.target
				t.multiplier = (Math.floor(this.x / t.pixelsperincrement) + t.lastmultiplier) % t.imageCount
				if (t.multiplier < 0) {
					t.multiplier += t.imageCount
				}
				t.imageElement.src = t.preloadedImages[t.multiplier].src
			}
		},
		onThrowUpdate: function() {
			var t = this.target
			t.multiplier = (Math.floor(this.x / t.pixelsperincrement) + t.lastmultiplier) % t.imageCount
			if (t.multiplier < 0) {
				t.multiplier += t.imageCount
			}
			t.imageElement.src = t.preloadedImages[t.multiplier].src
		},
		onThrowComplete: function() {
			var t = this.target
			t.lastmultiplier = t.multiplier % t.imageCount
		}
	})

	// trackpad swipe support for horizontal scrolling
	spriteslider.slider.addEventListener('wheel', function (event) {
		if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
			event.preventDefault()

			// calculate movement based on deltaX
			let direction = event.deltaX > 0 ? -1 : 1
			spriteslider.multiplier = (spriteslider.multiplier + direction + spriteslider.imageCount) % spriteslider.imageCount
			
			// update image based on new multiplier value
			spriteslider.imageElement.src = spriteslider.preloadedImages[spriteslider.multiplier].src
		}
	}, { passive: false })

}

// init lazyload
function initLazyLoad() {
	const lazyLoadInstance = new LazyLoad({ 
		elements_selector: '.lazy',
		container: select('.main-wrap')
	})
}

// init all sliders
function initSliders() {

	// product slider
	if($('.product-slider').length) {

		const product_slider_thumbs = new Swiper('.product-slider-thumbs', {
			spaceBetween: 10,
			slidesPerView: 5,
			freeMode: true,
			watchSlidesProgress: true
		})

		const product_slider = new Swiper('.product-slider', {
			slidesPerView: 1,
			loop: true,
			simulateTouch: true,
			allowTouchMove: true,
			autoHeight: false,
			calculateHeight: false,
			spaceBetween: 0,
			speed: 600,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			navigation: {
                nextEl: '.product-slider .next',
                prevEl: '.product-slider .prev'
            },
			pagination: {
				el: '.product-slider .progress',
				type: 'fraction'
			},
			thumbs: {
				swiper: product_slider_thumbs
			},
		})
		
	}

	// blog slider
	if($('.blog-slider').length) {

		const blog_slider = new Swiper('.blog-slider', {
			slidesPerView: 1,
			loop: false,
			simulateTouch: true,
			allowTouchMove: true,
			autoHeight: true,
			calculateHeight: false,
			spaceBetween: 15,
			speed: 600,
			mousewheel: {  
				forceToAxis: true
			},
			pagination: {
				el: '.blog-slider .pagination',
				clickable: true,
			},
			breakpoints: {
				767: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				1200: {
					slidesPerView: 3,
					spaceBetween: 30,
				}
			}
		})
	}

	// quiz slider
	if ($('.quiz-slider').length) {

		const quiz_slider = new Swiper('.quiz-slider', {
			slidesPerView: 1,
			loop: false,
			simulateTouch: false,
			allowTouchMove: false,
			autoHeight: true,
			calculateHeight: true,
			observeSlideChildren: true,
			observeParents: true,
			spaceBetween: 0,
			observer: true,
			speed: 600,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			pagination: {
				el: '.quiz-completion .progress',
				type: 'progressbar'
			},
			on: {
				slideChange: function () {
					const currentSlide = quiz_slider.slides[quiz_slider.activeIndex]
					validateSlide(currentSlide, false)
				}
			}
		})		
		
		$('.buttons .next-slide').click(function() {
			const currentSlide = quiz_slider.slides[quiz_slider.activeIndex];
		
			if (currentSlide.querySelector('[name="phone"]')) {
				let phone = $('.form-quiz [name=phone]').val();
				let formatPhone = "+1" + phone;
				if (!validatePhoneNumber(formatPhone)) {
					$(".phone-error").css("display", "block");
					console.log('Invalid phone number format. Please enter a valid number like 2345678901.');
					return false;
				}
				else{
					$(".phone-error").css("display", "none");					
				}
			}
		
			const isValid = validateSlide(currentSlide, true);
			if (isValid) {
				quiz_slider.slideNext();
			}
		});
		

		// $('.buttons .next-slide').click(function(){
		// 	const currentSlide = quiz_slider.slides[quiz_slider.activeIndex]
		// 	const isValid = validateSlide(currentSlide, true)
		// 	if (isValid) {
		// 		quiz_slider.slideNext()
		// 	}
		// })

		$('.buttons button').click(function(e){
			e.preventDefault()
		})

		$('.buttons .prev-slide').click(function () {
			quiz_slider.slidePrev()
		})

		$('.buttons .submit-quiz').click(function () {
			
		})

		// copies the code of the sibling <p> to the clipboard
		$('.copy-code').click(function(e){
			e.preventDefault()
			
			const codeElement = this.previousElementSibling
			const codeToCopy = codeElement.innerText
			navigator.clipboard.writeText(codeToCopy)
				.then(() => {
					console.log('Code copied to clipboard')
					codeElement.classList.add('copied')
					setTimeout(() => {
						codeElement.classList.remove('copied')
					}, 1000)
				})
				.catch((err) => {
					console.error('Failed to copy text to clipboard: ', err)
				})
		})

		// validate forms on content load
		document.addEventListener('DOMContentLoaded', function () {
			const slides = document.querySelectorAll('.swiper-slide')

			slides.forEach(slide => {
				const inputs = slide.querySelectorAll('input[required]')

				inputs.forEach(input => {
					input.addEventListener('input', () => {
						validateSlide(slide, false)
					})
					if (input.type === 'radio') {
						input.addEventListener('change', () => {
							validateSlide(slide, false)
						})
					}
				})

				validateSlide(slide, false)
			})
		})

		// validation function for individual slides
		function validateSlide(slide, showError) {
			const form = $(slide).closest('form')
			const inputs = $(slide).find('input[required]')
			let allValid = true

			inputs.each(function() {
				if (showError) {
					if (!form.validate().element(this)) {
						allValid = false
					}
				} else {
					if ($(this).val().trim() === '' || !form.validate().element(this)) {
						allValid = false
						setTimeout(() => {
							quiz_slider.updateAutoHeight(600)
						}, 100)
					}
				}
			})

			const nextButton = slide.querySelector('.next-slide')

			if (nextButton) {
				if (allValid) {
					nextButton.removeAttribute('disabled')
				} else {
					nextButton.setAttribute('disabled', 'true')
				}
			}

			return allValid
		}
	}

}

// init lenis
function initLenis() {
	lenis = new Lenis({
		duration: 2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
	})

	lenis.on('scroll', ScrollTrigger.update)

	gsap.ticker.add((time)=>{
		lenis.raf(time * 1000)
	})

	gsap.ticker.lagSmoothing(0)
}

function WakaForm(){
	$form_validator = $("#waka-form").validate();

	var waka_form = {
		file_inputs: [ '#upload-resume', '#upload-id' ],
		files_ready: {},
		seed: Math.random(),
		init: () => {

			$('#waka-form').submit( waka_form.submit_start );
		
		},
		submit_start: ( e ) => {
			e.preventDefault();
			console.log('submit_start');

			// jquery validator
			if ( !$form_validator.form() ) return false;

			$("#waka-form").addClass('sending');

			waka_form.files_ready = {};

			for ( let input of waka_form.file_inputs ) {
				console.log( input );
			
				let formdata = new FormData();
				let file = $( input )[0].files[0];
				formdata.append('file-data', file);
				console.log(file,formdata);
			
				$.ajax({
					type: 'POST',
					url: 'https://dev.theskylineagency.com/igethi/assets-shopify/form_uploads/parse_media.php',
					data: formdata,
					contentType: false,
					processData: false,
				}).done(function(response){
					console.log(response);
					//waka_form.files_ready[input] = location.origin + '/form_uploads/' + response;
					waka_form.files_ready[input] = 'https://dev.theskylineagency.com/igethi/assets-shopify/form_uploads/' + response;
					waka_form.submit_proceed();
				});
			}

			//$('#waka-form button').prop('disabled',true);
			// $.fancybox.open( $("#popup-success") );

			return false;
		},

		submit_proceed: () => {
			console.log('submit_proceed', waka_form.files_ready );
			if ( Object.keys( waka_form.files_ready ).length < waka_form.file_inputs.length ) return console.log('images not ready');
			let formdata = {};

			for ( let input of $('#waka-form').serializeArray() ) {
				formdata[input.name] = input.value;
			}

			for ( let input of waka_form.file_inputs ) {
				formdata[input] = waka_form.files_ready[input];
			}

			//return console.log( 'formdata:', formdata );

			$.ajax({
				type: 'POST',
				url: 'https://dev.theskylineagency.com/igethi/assets-shopify/waka-mailer.php',
				data: formdata,
				success: function(response) {
					
					setTimeout(function() {
						$("#waka-form")[0].reset();
						Fancybox.show([{
							src: '#popup-success-waka',
							type: 'inline',
						}]);
					}, 2000);
				},
				error: function() {
					setTimeout(function() {
						Fancybox.show([{
							src: '#popup-error-waka',
							type: 'inline',
						}]);
					}, 2000);
				},
				complete: function() {
					setTimeout(function() {
						$("#waka-form").removeClass('sending');
					}, 2000);
				}
			}).done(function(response){
				console.log(response);
				$("#waka-form")[0].reset();
				clearInputFiles();
			});
		}
	}

	return waka_form;
}

function clearInputFiles(){
	var $uploadWrapper = $('.upload-wrapper');
    
    $uploadWrapper.find('.file').val('');
    
    $uploadWrapper.find('.hollow-button').show();
    
    $uploadWrapper.find('.uploaded-file').hide();
    
    $uploadWrapper.find('.uploaded-file p').text('');
}

// validate forms
function validateForms() {
	if ($('.form-validate').length) {

		// age validation
        $.validator.addMethod("minimumAge", function(value, element) {
            if (value === "") return false
            
            // Parse the date string (MM/DD/YYYY)
            const parts = value.split('/')
            const birthDate = new Date(parts[2], parts[0] - 1, parts[1])
            
            // Calculate age
            const today = new Date()
            let age = today.getFullYear() - birthDate.getFullYear()
            const monthDiff = today.getMonth() - birthDate.getMonth()
            
            // Adjust age if birthday hasn't occurred this year
            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                age--
            }
            
            return age >= 21
        }, "You must be 21+ to apply")

		$('.form-validate').each(function () {
			var theForm = $(this)

			// validations
			let validationRules = {
				errorPlacement: function (error, element) {
					error.appendTo(element.closest('.form-line'))
					error.addClass('error-msg')
				},
				highlight: function(element) {
					$(element).closest('.form-line').addClass('error')
				},
				unhighlight: function(element) {
					$(element).closest('.form-line').removeClass('error')
				},
				submitHandler: function(form) {
					//event subWakaForm
				}
			}

			// add birthday validation if the field exists in this form
            if (theForm.find('.birthday-mask').length) {
                validationRules.rules = {
                    birthday: {
                        required: true,
                        minimumAge: true
                    }
                }
                validationRules.messages = {
                    birthday: {
                        required: "Please enter your birthday",
                        minimumAge: "You must be 21+ to apply"
                    }
                }
            }

            // initialize the jquery validation plugin for the form
            theForm.validate(validationRules)
		})

		// handle file uploads
		$('.file').change(function() {
			const input = this
			const file = input.files[0]
			const maxSize = 10 * 1024 * 1024 // 10MB in bytes
			const $uploadButton = $(this).siblings('.hollow-button')
			const $uploadedFile = $(this).siblings('.uploaded-file')
			
			// Reset the input and UI if no file is selected
			if (!file) {
				$uploadButton.show()
				$uploadedFile.hide()
				$uploadedFile.find('p').text('')
				return
			}
			
			// Check file size
			if (file.size > maxSize) {
				alert('File is too large. Maximum file size is 10MB.')
				input.value = '' // Clear the input
				return
			}
			
			// Update UI
			$uploadButton.hide()
			$uploadedFile.show()
			$uploadedFile.find('p').text(file.name)
			
			// Handle remove button click
			$uploadedFile.find('button').off('click').on('click', function(e) {
				e.preventDefault()
				input.value = '' // Clear the input
				$uploadedFile.hide()
				$uploadButton.show()
				$uploadedFile.find('p').text('')
			})
		})
	}
}

// disable console warnings and show the copyright message
function initCopyright() {
	//console.clear()

	const message = 'Hello dear dev friend!\nThis website was crafted by The Skyline Agency\n🚀 www.theskylineagency.com 🚀\n-------------------------------\nIf you are curious about the plugins used in this website, here they are:\nJquery 3.6.4, Fancybox, Swiper, Gsap, ScrollTrigger, Vanilla Lazyload, Lenis, Klaviyo and Jquery Validate'
	
	const style = 'color: #DA9329; font-size: 12px; font-weight: bold; background-color: #0d0e13; padding: 8px'
	
	console.log(`%c${message}`, style)
}

// opening animation
function openingAnimation() {

	const opening = gsap.timeline()

	// check if the user already confirmed he´s over 21
	const userIs21 = getCookie('userIs21');
    
	// if he didn´t... show the opening animation
	if (!userIs21) {
		opening.set('body', {
			overflow: 'hidden'
		})

		opening.to('#opening', {
			autoAlpha: 1,
			duration: 0
		})

		opening.to('#opening .flex', {
			opacity: 1,
			duration: 2,
			ease: 'linear'
		}, .5)

	// otherwise, remove the opening animation
	} else {
		if($('#opening').length) {
			$('#opening').remove()
		}

		// dispatch an event to open the newsletter popup
		setTimeout(() => {
			document.dispatchEvent(new Event('openNewsletterPopup'))
		}, 5000)
	}

	// if the user clicks on the enter button, store a cookie and hide the opening animation
	$('#opening .enter').click(function(){
		
		setCookie('userIs21', 'true', 7);

		gsap.to('body', {
			overflow: 'auto'
		})

		gsap.to('#opening', {
			autoAlpha: 0,
			duration: .6
		})

		// dispatch an event to open the newsletter popup
		setTimeout(() => {
			document.dispatchEvent(new Event('openNewsletterPopup'))
		}, 5000)
	})
	
}

// init general fixes and other functions
function initFixes() {

	// adjust the home video height
	if($('#video-home').length) {

		const topMenuHeight = $('#top-menu').outerHeight()
		const bannerVideoHeight = $('#video-home').outerHeight()
		$('#video-home').css('height', (topMenuHeight + bannerVideoHeight) + 'px')

		// adjust the home video height on resize
		$(window).on('resize', function() {

			function setVideoHeight() {
				const topMenuHeight = $('#top-menu').outerHeight()
				$('#video-home').css('height', '')
				const bannerVideoHeight = $('#video-home').outerHeight()
				$('#video-home').css('height', topMenuHeight + bannerVideoHeight + 'px')
			}

			setVideoHeight()

			setTimeout(function() {
				setVideoHeight()
			}, 300)
		})
	}

	// add a hover state in the middle product by default
	if($('.products-featured-by-default').length) {
		$('.products-featured-by-default .row > div:nth-child(2) .product-block').addClass('hover')

		$('.products-featured-by-default .product-block').on('mouseenter', function() {
			$('.products-featured-by-default .product-block').removeClass('hover')
			setTimeout(() => {
				$(this).addClass('hover')
			}, 10)
		})

		$('.products-featured-by-default .product-block').on('mouseleave', function() {
			$(this).removeClass('hover')
		})
	}
}

// init popups
function initPopups() {

	// newsletter popup
	if ($('.popup-newsletter').length) {

		// listen for the openNewsletterPopup event
		document.addEventListener('openNewsletterPopup', function() {
			const closedNewsletter = getCookie('closedNewsletter')
    
			// if the user hasn't clicked on the close button, show the popup
			if (!closedNewsletter) {

				gsap.to('.popup-newsletter', {
					display: 'block',
					duration: 0
				})
				
				gsap.fromTo('.popup-newsletter', {
					autoAlpha: 0,
					y: 300
				}, {
					autoAlpha: 1,
					duration: .6,
					y: 0
				}, '+3')

			} else {
				$('.popup-newsletter').remove()
			}
		})

		// close the newsletter popup and store a cookie (in days)
		$('.close-popup-newsletter').click(function(){
			setCookie('closedNewsletter', 'true', 7)
			$('.popup-newsletter').fadeOut()
		})
	}
}

// init mask
function initMask() {
    if(select('.birthday-mask')) {
        IMask(
            select('.birthday-mask'), {
                mask: '00/00/0000',
                lazy: true
            }
        )
    }
}


// fire all scripts
function initScripts() {
	initLenis()
	initClickAndKeyFunctions()
	initSliders()
	initFancybox()
	initLazyLoad()
	initCopyright()
	openingAnimation()
	scrollTriggerAnimations()
	initFixes()
	initPopups()
	validateForms()
	initMask()

	//banner_countdown()

	setTimeout(function() {
		ScrollTrigger.refresh()
	}, 1000)
}

initScripts()

// if the user is entering the website for the first time, this will detect the opening animation and animate the banner accordingly
document.addEventListener('animationIn', function() {

	var tl = gsap.timeline()

	var text = new SplitText('#banner h1', { 
		type: 'lines, words, chars',
		linesClass: 'split-line'
	})

	tl.from('#fishes video', {
		autoAlpha: 0, 
		yPercent: 40,
		duration: 1,
		ease: 'circ.out', 
	}, '+=.7')

	tl.from(text.chars, {
		duration: .75,
		ease: 'circ.out', 
		yPercent: 100,
		autoAlpha: 0, 
		stagger: 0.0375
	}, '-=.75')

})

$(document).ready(function () {

	// Clean up NYE26 discount removal flag from URL
	if (window.location.href.includes('_nyed=1')) {
		const cleanUrl = new URL(window.location.href);
		cleanUrl.searchParams.delete('_nyed');
		window.history.replaceState({}, '', cleanUrl.toString());
	}

    var currentPath = window.location.pathname;
	if (currentPath === "/cart") {
	   window.location.href = '/products?open-cart=true';
	}
 
	var queryString = window.location.search;  
	if (queryString.indexOf("open-cart=true") !== -1 && queryString.indexOf("defaultsel") === -1) {
		console.log('querystring', queryString);
		$(".open-cart").click();
		//openCart();
	}

	// Auto-select purchase options based on URL parameters
	function autoSelectPurchaseOption() {
		// Find all product blocks on the page
		const productBlocks = document.querySelectorAll('.product-block');
		
		// Check for one-time purchase selection
		if (queryString.indexOf("defaultsel=onetime") !== -1) {
			productBlocks.forEach((block, blockIndex) => {
				// Find radio buttons within this specific product block
				const selectors = [
					'input[name="purchaseType"][value="one-time"]',
					'input[value="one-time"]'
				];
				
				let radios = [];
				selectors.forEach(selector => {
					const found = block.querySelectorAll(selector);
					radios = radios.concat(Array.from(found));
				});
				
				selectPurchaseRadiosInBlock(block, radios, 'one-time', blockIndex + 1);
			});
		}
		
		// Check for subscription selection  
		if (queryString.indexOf("defaultsel=subscription") !== -1) {
			productBlocks.forEach((block, blockIndex) => {
				const selectors = [
					'input[name="purchaseType"][value="subscription"]',
					'input[value="subscription"]'
				];
				
				let radios = [];
				selectors.forEach(selector => {
					const found = block.querySelectorAll(selector);
					radios = radios.concat(Array.from(found));
				});
				
				selectPurchaseRadiosInBlock(block, radios, 'subscription', blockIndex + 1);
			});
		}
	}

	// Helper function to select radio buttons within a specific product block
	function selectPurchaseRadiosInBlock(block, radios, type, blockNumber) {
		if (radios.length === 0) {
			return;
		}
		
		radios.forEach(function(radio, index) {
			// Uncheck other radio buttons with the same name within this block only
			if (radio.name) {
				const otherRadiosInBlock = block.querySelectorAll(`input[name="${radio.name}"]`);
				otherRadiosInBlock.forEach(r => r.checked = false);
			}
			
			// Select this radio button
			radio.checked = true;
			
			// Trigger multiple events for compatibility with different handlers
			['change', 'click', 'input'].forEach(function(eventType) {
				try {
					const event = new Event(eventType, { bubbles: true, cancelable: true });
					radio.dispatchEvent(event);
				} catch (e) {
					// Silent error handling
				}
			});
		});
	}

	// Execute the auto-selection with delay to ensure DOM is ready
	function executeAutoSelection() {
		autoSelectPurchaseOption();
		
		// Try again after a short delay in case elements are loaded dynamically
		setTimeout(function() {
			autoSelectPurchaseOption();
		}, 500);
	}

	// Execute immediately and also after DOM is fully loaded
	executeAutoSelection();

	if(Cookies.get('register_igethi') == 1){
		document.cookie = 'register_igethi=0; path=/;';
		select('.popup-success-register').click();
	 }
	 else{
   }

   if(queryString.indexOf("contact_posted=true") !== -1 && Cookies.get('contact_igethi') == 1){		
		document.cookie = 'contact_igethi=0; path=/;';
		setInterval(select('.contact-success').click(), 900);
 	}
	else{
	}

	//waka_form.init();
	var subWakaForm = WakaForm();
    subWakaForm.init();
})

//shopify
function openCart() {
	total_original = 0;
	const cartItemHolder = $("#products");
	cartItemHolder.empty();
	$("#loading").css("display", "block");
	$('body').toggleClass('cart-menu-open');
	setTimeout(async () => {
        await fetchCart();

		setTimeout(() => {
			const savedCode = localStorage.getItem("appliedDiscountCode");
			const codeInput = document.getElementById("code");
			
			if (codeInput && savedCode) {
				codeInput.value = savedCode;
				applyDiscount();
			} else if (codeInput) {
				// Check if there's a discount code in URL parameters
				const urlDiscountCode = getQueryParameter("discount");
				if (urlDiscountCode) {
					codeInput.value = urlDiscountCode;
					localStorage.setItem("appliedDiscountCode", urlDiscountCode);
					applyDiscount();
				}
			}
		}, 300);
    }, 1000);
}


//variables
let freeShipping = 75.00;
let calcDiscount = 0;
let total_original = 0;

function closeCart() {
	$('body').removeClass('cart-menu-open');
}

function addToCart(variantId) {
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            id: variantId,
            quantity: 1
        },
        dataType: 'json',
        success: function (data) {
        },
        error: function (error) {
        }
    });
}

function removeCart(variantId) {
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
            id: variantId,
            quantity: 0
        },
        dataType: 'json',
        success: function (data) {
        },
        error: function (error) {
        }
    });
}

async function fetchCart() {
	$.ajax({
		type: 'GET',
		url: '/cart.js',
		dataType: 'json',
		success: function (cart) {
			renderCart(cart);
		},
	});
}

const cartItem =
	`<div class='cart-product-block' data-cart-item='%CART_KEY%'>

		<a class='image'>
			<img src='%PRODUCT_IMAGE%' alt='%PRODUCT_TITLE%'>
		</a>

		<div class='infos'>

			<a class='h4 product-name'>
				%PRODUCT_TITLE%
			</a>

			<p class='h4 product-price'>
				<span class='old'>
					%PRODUCT_OLD_PRICE%
				</span>
				<span class='current'>
					%PRODUCT_PRICE%
				</span>
			</p>

			<div class='quantity-plan'>

				<div class='quantity'>
					<div class='form-line'>
						<div class='line-wrapper'>

							<input
								type='number'
								min='1'
								max='8'
								value='%QUANTITY%'
								placeholder='0'
								id='quantity-%CART_KEY%'
								class='input'
								onfocusout="changeItem(%PRODUCT_ID%, this.value, %PRODUCT_PLAN_ID%)" 
							/>

							<div class='buttons'>

								<button class='increase' id='plus-%CART_KEY%' onClick='addQty(%PRODUCT_ID%, %QUANTITY%, %PRODUCT_PLAN_ID%)'>
									<svg width="27" height="16" viewBox="0 0 27 16" xmlns="http://www.w3.org/2000/svg"><path d="M13.1104 0.507298C13.6377 0.507298 14.1064 0.683098 14.458 1.0347L25.708 12.2847C26.4697 12.9878 26.4697 14.2183 25.708 14.9214C25.0049 15.6831 23.7744 15.6831 23.0713 14.9214L13.1104 5.019L3.208 14.9214C2.5049 15.6831 1.2744 15.6831 0.571297 14.9214C-0.190403 14.2183 -0.190403 12.9878 0.571297 12.2847L11.8213 1.0347C12.1729 0.683098 12.6416 0.507298 13.1104 0.507298Z"></path></svg>
								</button>

								<button class='decrease' id='minus-%CART_KEY%' onClick='subQty(%PRODUCT_ID%, %QUANTITY%, %PRODUCT_PLAN_ID%)'>
									<svg width="27" height="16" viewBox="0 0 27 16" xmlns="http://www.w3.org/2000/svg"><path d="M13.1689 15.4927C12.6416 15.4927 12.1729 15.3169 11.8213 14.9653L0.571289 3.71533C-0.19043 3.01221 -0.19043 1.78174 0.571289 1.07861C1.27441 0.316895 2.50488 0.316895 3.20801 1.07861L13.1689 10.981L23.0713 1.07861C23.7744 0.316895 25.0049 0.316895 25.708 1.07861C26.4697 1.78174 26.4697 3.01221 25.708 3.71533L14.458 14.9653C14.1064 15.3169 13.6377 15.4927 13.1689 15.4927Z"></path></svg>
								</button>

							</div>
							
						</div>
					</div>
				</div>

				<p class='plan'>
					%PRODUCT_PLAN%
				</p>

			</div>

		</div>
		
		<button onClick="changeItem(%PRODUCT_ID%, 0, %PRODUCT_PLAN_ID%)" class="remove-product">
			<svg width="18" height="21" viewBox="0 0 18 21" xmlns="http://www.w3.org/2000/svg"><path d="M17.125 3C17.4375 3 17.75 3.3125 17.75 3.625C17.75 3.97656 17.4375 4.25 17.125 4.25H16.3828L15.4062 18.1953C15.2891 19.5234 14.1953 20.5 12.9062 20.5H5.05469C3.76562 20.5 2.67188 19.5234 2.55469 18.1953L1.57812 4.25H0.875C0.523438 4.25 0.25 3.97656 0.25 3.625C0.25 3.3125 0.523438 3 0.875 3H4.58594L5.60156 1.39844C5.91406 0.851562 6.53906 0.5 7.16406 0.5H10.7969C11.4219 0.5 12.0469 0.851562 12.3594 1.39844L13.375 3H17.125ZM7.16406 1.75C6.96875 1.75 6.77344 1.86719 6.65625 2.0625L6.03125 3H11.9297L11.3047 2.0625C11.1875 1.86719 10.9922 1.75 10.7969 1.75H7.16406ZM15.1328 4.25H2.82812L3.80469 18.1172C3.84375 18.7422 4.39062 19.25 5.05469 19.25H12.9062C13.5703 19.25 14.1172 18.7422 14.1562 18.1172L15.1328 4.25Z"></path></svg>                
		</button>

      </div>`;

function changeItem(productId, quantity, sellingPlanId = null) {
    $("#cart-menu .wrapper").css("opacity", "1");

    if (quantity > 8) {
        quantity = 8;
    }
	
	// Normalize sellingPlanId: convert string 'null' or 'undefined' to actual null
	if (sellingPlanId === 'null' || sellingPlanId === 'undefined' || sellingPlanId === '') {
		sellingPlanId = null;
	}

    $.getJSON('/cart.js', function(cart) {
        let line = null;

        // Find the FIRST matching item only - use for loop instead of forEach to allow break
        for (let index = 0; index < cart.items.length; index++) {
            const item = cart.items[index];
            
            if (item.id === productId) {
                // Check if selling plans match
                const itemHasSellingPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
                const itemSellingPlanId = itemHasSellingPlan ? item.selling_plan_allocation.selling_plan.id : null;
                
                // Match if both have no selling plan OR both have the same selling plan ID
                const plansMatch = (sellingPlanId === null && itemSellingPlanId === null) || 
                                  (sellingPlanId !== null && itemSellingPlanId === sellingPlanId);
                
                if (plansMatch) {
                    line = index + 1;
                    break; // Stop at the first match to avoid overwriting
                }
            }
        }

        if (line !== null) {            
            const data = {
                quantity: quantity,
                line: line
            };

            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: data,
                dataType: 'json',
                success: function(cart) {
                    renderCart(cart);
                    $("#cart-menu .wrapper").css("opacity", "1");
					
					var inp = document.getElementById("code");
					if(inp != null){
						applyDiscount(true); // Skip final render since we just rendered
					}
                },
                error: function() {
                    $("#cart-menu .wrapper").css("opacity", "1");
                }
            });
        } else {
            $("#cart-menu .wrapper").css("opacity", "1");
        }
    });
}

let nQty = 0;

function addQty(productId, quantity, sellingPlanId = null) {

	total_original = 0;

	$("#cart-menu .wrapper").css("opacity", "1");

	$("#total").addClass("shimmer");
	$(".discountvalue").addClass("shimmer");
	$("#total-original").addClass("shimmer");
	$("#total-original").css("color", "#0000");
	$("#shipping-free").addClass("shimmer");

	var nquantity = quantity + 1;
	nquantity = nquantity > 8 ? 8 : nquantity;
	
	// Normalize sellingPlanId: convert string 'null' or 'undefined' to actual null
	if (sellingPlanId === 'null' || sellingPlanId === 'undefined' || sellingPlanId === '') {
		sellingPlanId = null;
	}

	$.getJSON('/cart.js', function(cart) {
        let line = null;

        // Find the FIRST matching item only - use for loop instead of forEach to allow break
        for (let index = 0; index < cart.items.length; index++) {
            const item = cart.items[index];
            
            if (item.id === productId) {
                // Check if selling plans match
                const itemHasSellingPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
                const itemSellingPlanId = itemHasSellingPlan ? item.selling_plan_allocation.selling_plan.id : null;
                
                // Match if both have no selling plan OR both have the same selling plan ID
                const plansMatch = (sellingPlanId === null && itemSellingPlanId === null) || 
                                  (sellingPlanId !== null && itemSellingPlanId === sellingPlanId);
                
                if (plansMatch) {
                    line = index + 1;
                    break; // Stop at the first match to avoid overwriting
                }
            }
        }

        if (line !== null) {            
            const data = {
                quantity: nquantity,
                line: line
            };


            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: data,
                dataType: 'json',
                success: function(cart) {
                    renderCart(cart);
                    $("#cart-menu .wrapper").css("opacity", "1");

					var inp = document.getElementById("code");
					if(inp != null){
						if(inp.value != ""){
							applyDiscount(true); // Skip final render since we just rendered
						}
						else{
							$("#total").removeClass("shimmer");
							$(".discountvalue").removeClass("shimmer");
							$("#total-original").removeClass("shimmer");
							$("#shipping-free").removeClass("shimmer");
							$("#total-original").css("color", "#999");
						}
					}
					else{
						$("#total").removeClass("shimmer");
						$(".discountvalue").removeClass("shimmer");
						$("#total-original").removeClass("shimmer");
						$("#shipping-free").removeClass("shimmer");
						$("#total-original").css("color", "#999");
					}

					// Removed duplicate applyDiscount() call
                },
                error: function() {
                    $("#cart-menu .wrapper").css("opacity", "1");
                }
            });
        } else {
            $("#cart-menu .wrapper").css("opacity", "1");
            removeShimmerCart();
        }
    });
}

function subQty(productId, quantity, sellingPlanId = null) {

	total_original = 0;

	$("#cart-menu .wrapper").css("opacity", "1");
	$("#total").addClass("shimmer");
	$(".discountvalue").addClass("shimmer");
	$("#total-original").addClass("shimmer");
	$("#total-original").css("color", "#0000");
	$("#shipping-free").addClass("shimmer");

	var nquantity = quantity - 1;
	nquantity = nquantity > 8 ? 8 : nquantity;
	
	// Normalize sellingPlanId: convert string 'null' or 'undefined' to actual null
	if (sellingPlanId === 'null' || sellingPlanId === 'undefined' || sellingPlanId === '') {
		sellingPlanId = null;
	}

	$.getJSON('/cart.js', function(cart) {
        let line = null;

        // Find the FIRST matching item only - use for loop instead of forEach to allow break
        for (let index = 0; index < cart.items.length; index++) {
            const item = cart.items[index];
            
            if (item.id === productId) {
                // Check if selling plans match
                const itemHasSellingPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
                const itemSellingPlanId = itemHasSellingPlan ? item.selling_plan_allocation.selling_plan.id : null;
                
                // Match if both have no selling plan OR both have the same selling plan ID
                const plansMatch = (sellingPlanId === null && itemSellingPlanId === null) || 
                                  (sellingPlanId !== null && itemSellingPlanId === sellingPlanId);
                
                if (plansMatch) {
                    line = index + 1;
                    break; // Stop at the first match to avoid overwriting
                }
            }
        }

        if (line !== null) {            
            const data = {
                quantity: nquantity,
                line: line
            };


            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: data,
                dataType: 'json',
                success: function(cart) {
                    renderCart(cart);
                    $("#cart-menu .wrapper").css("opacity", "1");

					var inp = document.getElementById("code");
					if(inp != null){
						if(inp.value != ""){
							applyDiscount(true); // Skip final render since we just rendered
						}
						else{
							$("#total").removeClass("shimmer");
							$(".discountvalue").removeClass("shimmer");
							$("#total-original").removeClass("shimmer");
							$("#shipping-free").removeClass("shimmer");
							$("#total-original").css("color", "#999");
						}
					}
					else{
						$("#total").removeClass("shimmer");
						$(".discountvalue").removeClass("shimmer");
						$("#total-original").removeClass("shimmer");
						$("#total-original").css("color", "#999");
						$("#shipping-free").removeClass("shimmer");
					}

					// Removed duplicate applyDiscount() call
                },
                error: function() {
                    $("#cart-menu .wrapper").css("opacity", "1");
                }
            });
        } else {
            $("#cart-menu .wrapper").css("opacity", "1");
            removeShimmerCart();
        }
    });
}

function addShimmerCart(){
	$("#total").addClass("shimmer");
	$(".discountvalue").addClass("shimmer");
	$("#total-original").addClass("shimmer");
	$("#total-original").css("color", "#0000");
	$("#shipping-free").addClass("shimmer");
}

function removeShimmerCart(){
	$("#total").removeClass("shimmer");
	$(".discountvalue").removeClass("shimmer");
	$("#total-original").removeClass("shimmer");
	$("#total-original").css("color", "#999");
	$("#shipping-free").removeClass("shimmer");
}

function renderCart(cart) {
	
	total_original = 0;
	//console.log(JSON.stringify(cart));
	const cartItemHolder = $("#products");

	cartItemHolder.empty();

	if (cart.items.length != 0) {
		$("#empty").css("display", "none");
		$(".empty-cart-total").css("display", "block");

		cartItemHolder.removeClass("hidden");
		$('#protection').css("display", "block");
		$(".discount").css("display", "block");
	} else {
		$("#empty").css("display", "block");		
		$(".empty-cart-total").css("display", "none");
		$(".discount").css("display", "none");
		cartItemHolder.addClass("hidden");
		$('#protection').css("display", "none");

		//localStorage.removeItem("appliedDiscountCode");
	}

	var cartCount = $(".cart-items.text-small");

	cartCount.text(cart.item_count);

	// Calculate original subtotal manually from items (more reliable)
	let calculatedOriginalSubtotal = 0;
	cart.items.forEach(function(item) {
		// Always use original_price if available (price before any line-item discounts)
		// If no original_price, fall back to price
		const itemPrice = item.original_price || item.price;
		calculatedOriginalSubtotal += (itemPrice * item.quantity);
	});
	
	// Use the calculated original subtotal (more reliable than cart values)
	var originalSubtotalInCents = Math.round(calculatedOriginalSubtotal);
	var originalSubtotal = originalSubtotalInCents / 100;
	
	// Calculate subtotal by subtracting discount from original (more precise than cart.total_price)
	// This ensures cents are calculated correctly
	var discountInCents = Math.round(cart.total_discount);
	var subtotalInCents = originalSubtotalInCents - discountInCents;
	var subTotalPrice = subtotalInCents / 100;	
	var subtotal = subTotalPrice.toLocaleString("en-US", { style: "currency", currency: "USD" });	

	var cartCountItems = 0;

	// BOGO tracking variables
	let hasBOGOProduct = false;
	let hasBOGO4PKProduct = false;
	let hasBOGOFreeItem = false;
	const BOGO_PRODUCT_IDS = [7351018749994, 7728722673706];
	const BOGO4PK_VARIANT_ID = 43797319319594;
	const BOGO_FREE_VARIANT_ID = 43797319254058;
	
	// Check if BOGO codes are active BEFORE the loop
	const currentDiscountCode = getCouponCode();
	const isBOGORPActive = currentDiscountCode && currentDiscountCode.toLowerCase() === 'bogorp';
	const isBOGO4PKActive = currentDiscountCode && currentDiscountCode.toLowerCase() === 'bogo4pk';
	const isNYE26Active = currentDiscountCode && currentDiscountCode.toUpperCase() === 'NYE26';
	const isAnyBOGOActive = isBOGORPActive || isBOGO4PKActive;

	cart.items.forEach(function (item, index) {

		//console.log('cart', item);
		if(item.id == 42691880222762){
			removeCart(42691880222762)
		}

		//console.log("Selling Plan" + (item.hasOwnProperty("selling_plan_allocation") ? item.selling_plan_allocation.selling_plan.name : "Didnt have plan"));
		//console.log("Selling Plan: " + (item.hasOwnProperty("selling_plan_allocation") ? item.selling_plan_allocation.selling_plan.id : "Didnt have plan"));

		// Check if this is a BOGO product (one-time purchase only)
		if (BOGO_PRODUCT_IDS.includes(item.product_id) && !item.hasOwnProperty("selling_plan_allocation")) {
			hasBOGOProduct = true;
		}

		// Check if this is a BOGO4PK product (one-time purchase only)
		if (item.id === BOGO4PK_VARIANT_ID && !item.hasOwnProperty("selling_plan_allocation")) {
			hasBOGO4PKProduct = true;
		}

		// Check if the free BOGO item is already in cart
		if (item.id === BOGO_FREE_VARIANT_ID) {
			hasBOGOFreeItem = true;
		}

		var cost = item.price;
		// Only treat as FREE item if BOGO codes are active
		var isBOGOFreeItem = (item.id === BOGO_FREE_VARIANT_ID && isAnyBOGOActive);

		cost = (cost / 100).toLocaleString("en-US", { style: "currency", currency: "USD" });

		var compareAtPrice = item.hasOwnProperty("selling_plan_allocation") && item.selling_plan_allocation.hasOwnProperty("compare_at_price")
		? (item.selling_plan_allocation.compare_at_price / 100).toLocaleString("en-US", { style: "currency", currency: "USD" })
		: "";

		var sellingPlanName = item.hasOwnProperty("selling_plan_allocation") ? item.selling_plan_allocation.selling_plan.name : "";	
		var sellingPlanId = item.hasOwnProperty("selling_plan_allocation") ? item.selling_plan_allocation.selling_plan.id : "";	
		
		// Create unique cart key for each item (using key property from Shopify cart)
		var cartKey = item.key || (item.id + '-' + (sellingPlanId || 'onetime'));

		var cartItem2 = replaceAll(cartItem, "%PRODUCT_TITLE%", item.title);
		cartItem2 = replaceAll(cartItem2, "%QUANTITY%", item.quantity);
		cartItem2 = replaceAll(cartItem2, "%ID%", item.id);
		cartItem2 = replaceAll(cartItem2, "%CART_KEY%", cartKey);
		cartItem2 = replaceAll(cartItem2, "%PRODUCT_IMAGE%", (item.image).replace(".png", "_500x500.png").replace(".jpg", "_500x500.jpg"));

		// Show "FREE" for BOGO item ONLY when BOGO codes are active, otherwise show price
		if (isBOGOFreeItem) {
			cartItem2 = replaceAll(cartItem2, "%PRODUCT_PRICE%", "FREE");
			// Disable increase/decrease buttons for free item by adding 'disabled' attribute
			cartItem2 = cartItem2.replace(/onClick='addQty\(/g, "disabled onClick='return false; addQty(");
			cartItem2 = cartItem2.replace(/onClick='subQty\(/g, "disabled onClick='return false; subQty(");
			cartItem2 = cartItem2.replace(/onfocusout="changeItem\(/g, "disabled onfocusout=\"return false; changeItem(");
		} else {
			cartItem2 = replaceAll(cartItem2, "%PRODUCT_PRICE%", cost);
		}

		// Don't add free item price to total ONLY when it's treated as FREE
		if (!isBOGOFreeItem) {
			total_original += parseFloat(cost.replace("$", "") * item.quantity);
		}

		//cartItem2 = replaceAll(cartItem2, "%PRODUCT_PLAN%", item.hasOwnProperty("selling_plan_allocation") ? item.selling_plan_allocation.selling_plan.name : "");
		if (sellingPlanName === "") {
			cartItem2 = cartItem2.replace(/<p class=['"]plan['"][^>]*>[\s\S]*?<\/p>/g, "");
			cartItem2 = replaceAll(cartItem2, "%PRODUCT_PLAN_ID%", null);
		} else {
			cartItem2 = replaceAll(cartItem2, "%PRODUCT_PLAN%", sellingPlanName);
			cartItem2 = replaceAll(cartItem2, "%PRODUCT_PLAN_ID%", sellingPlanId);
		}

		//cartItem2 = replaceAll(cartItem2, "%PRODUCT_OLD_PRICE%", compareAtPrice);
		if (compareAtPrice === "") {
			cartItem2 = cartItem2.replace(/<span class=['"]old['"][^>]*>[\s\S]*?<\/span>/g, "");
		} else {
			cartItem2 = replaceAll(cartItem2, "%PRODUCT_OLD_PRICE%", compareAtPrice);
		}

		cartItem2 = replaceAll(cartItem2, "%PRODUCT_ID%", item.id);
		cartItem2 = replaceAll(cartItem2, "%HANDLE%", item.handle);

		cartCountItems += parseInt(item.quantity);

		cartItemHolder.prepend(cartItem2);
	});

	// Check if BOGO free item should be removed (addition is handled in applyDiscount())
	// Note: currentDiscountCode, isBOGORPActive, and isBOGO4PKActive are already defined before the loop
	
	// Check NYE26 promotion eligibility
	if (isNYE26Active) {
		const NYE26_PRODUCT_IDS = [7351018749994, 7728722673706];
		let totalNYE26Items = 0;
		cart.items.forEach(function (item) {
			if (NYE26_PRODUCT_IDS.includes(item.product_id)) {
				totalNYE26Items += item.quantity;
			}
		});
		
		// If less than 3 items, remove the discount code
		if (totalNYE26Items < 3) {
			// Check if Shopify still has the discount applied
			const hasShopifyDiscount = cart.total_discount > 0;
			
			localStorage.removeItem("appliedDiscountCode");
			const codeInput = document.getElementById("code");
			if (codeInput) {
				codeInput.value = "";
			}
			$("#response").hide();
			$("#total-original").hide();
			$(".discountvalue").text("TBD");
			
			// If Shopify still has discount, need to clear it by reloading without discount
			if (hasShopifyDiscount && !window.location.href.includes('_nyed=1')) {
				// Add a flag to prevent infinite loop
				const currentUrl = new URL(window.location.href);
				currentUrl.searchParams.set('_nyed', '1');
				currentUrl.searchParams.set('open-cart', 'true');
				window.location.href = currentUrl.toString();
			}
		}
	}
	
	// Remove BOGO discount code if required products are not in cart
	if (isBOGORPActive && !hasBOGOProduct) {
		localStorage.removeItem("appliedDiscountCode");
		const codeInput = document.getElementById("code");
		if (codeInput) {
			codeInput.value = "";
		}
		$("#response").hide();
		$("#total-original").hide();
	}
	
	if (isBOGO4PKActive && !hasBOGO4PKProduct) {
		localStorage.removeItem("appliedDiscountCode");
		const codeInput = document.getElementById("code");
		if (codeInput) {
			codeInput.value = "";
		}
		$("#response").hide();
		$("#total-original").hide();
	}
	
	// Remove free item ONLY if BOGO codes are active but conditions are no longer met
	// Don't remove if the item was added manually (no BOGO codes active)
	if (hasBOGOFreeItem && isAnyBOGOActive) {
		const shouldRemoveFreeItem = 
			// Remove if no BOGO products and no BOGO4PK variant
			(!hasBOGOProduct && !hasBOGO4PKProduct) ||
			// Remove if has BOGO product but wrong discount code
			(hasBOGOProduct && !hasBOGO4PKProduct && !isBOGORPActive) ||
			// Remove if has BOGO4PK variant but wrong discount code
			(hasBOGO4PKProduct && !hasBOGOProduct && !isBOGO4PKActive);
			
		if (shouldRemoveFreeItem) {
			changeItem(BOGO_FREE_VARIANT_ID, 0, null);
		}
	}

	// Determine which original price to show
	// For BOGO codes: use manually calculated total_original (excludes free item)
	// For other discounts: ALWAYS use cart.items_subtotal_price (official Shopify value)
	let displayOriginalPrice = originalSubtotal; // Default to Shopify's official subtotal
	
	if (isAnyBOGOActive) {
		// For BOGO codes only, use manually calculated total (excludes free item)
		displayOriginalPrice = total_original;
	}
	
	// Update the SUBTOTAL display (with discount applied)
	$("#total").text(subtotal);
	
	// Update the ORIGINAL PRICE display (without discount)
	const formattedOriginalPrice = "$" + parseFloat(displayOriginalPrice).toFixed(2);
	$("#total-original").text(formattedOriginalPrice);
	
	// Show/hide original price based on whether there's a REAL discount
	// Only show if the values are actually different
	const hasRealDiscount = parseFloat(displayOriginalPrice.toFixed(2)) !== parseFloat(subTotalPrice.toFixed(2));
	
	if (hasRealDiscount) {
		$("#total-original").show();
		
		// Use Shopify's cart.total_discount for accurate discount amount
		const discountAmountInCents = Math.round(cart.total_discount);
		const discountAmount = discountAmountInCents / 100;
		
		const currentDiscountCode = getCouponCode();
		
		// Only show discount value if it's not a free shipping code or BOGO codes
		if (currentDiscountCode && 
		    currentDiscountCode.toUpperCase() !== 'FREESHIP' && 
		    currentDiscountCode.toUpperCase() !== 'SHIPCHERRY' && 
		    currentDiscountCode.toLowerCase() !== 'freeship1' &&
		    currentDiscountCode.toUpperCase() !== 'SHIP10MG' &&
		    currentDiscountCode.toUpperCase() !== 'BOGORP' &&
		    currentDiscountCode.toUpperCase() !== 'BOGO4PK') {
			$(".discountvalue").text("$" + discountAmount.toFixed(2));
		}
		
		// Special handling for NYE26: always show discount value when active
		if (currentDiscountCode && currentDiscountCode.toUpperCase() === 'NYE26') {
			$(".discountvalue").text("$" + discountAmount.toFixed(2));
		}
	} else {
		$("#total-original").hide();
	}

	//calc free shipping - use subtotal after discount for shipping calculation
	getCalcFreeShipping(subTotalPrice);

	//$("#cartCount").text(cart.items.length);
	$("#cartCount").text(cartCountItems);

	$("#loading").css("display", "none");
}

function replaceAll(str, find, replace) {
	return str.replace(new RegExp(find, 'g'), replace);
}

function getCouponCode() {
    const savedCode = localStorage.getItem("appliedDiscountCode");
	//console.log('coupon code', savedCode);

    if (savedCode) {
        return savedCode;
    } else {
        return null;
    }
}

function getCalcFreeShipping(subtotal){	

	const couponCode = getCouponCode();

	//var inp = document.getElementById("code");
	var inp = document.getElementById("code").value;

	if (couponCode == 'freeship1' || couponCode === 'FREESHIP' || couponCode === 'freeship' || couponCode.toUpperCase() === 'SHIPCHERRY' || inp === 'FREESHIP' || inp === 'freeship' || inp.toUpperCase() === 'SHIPCHERRY' || couponCode.toUpperCase() === 'SHIP10MG') {				
		document.getElementById("code").value = couponCode;	
		$("#shipping-free").text("FREE");
		$(".free-shipping-counter p").html('Congratulations! You got <span>FREE</span> shipping.');	
		
		$(".discountvalue").text("TBD");
		calcDiscount = 0;
		
	} else {
		// Calculate in cents for precision (subtotal is already a number from subTotalPrice)
		const subtotalInCents = Math.round(subtotal * 100);
		const freeShippingInCents = Math.round(freeShipping * 100);
		
		if(subtotalInCents >= freeShippingInCents){
			$("#shipping-free").text("FREE");
			$(".free-shipping-counter p").html('Congratulations! You got <span>FREE</span> shipping.');
		}
		else{
			const untilFreeShippingInCents = freeShippingInCents - subtotalInCents;
			const untilFreeShipping = untilFreeShippingInCents / 100;
	
			if(untilFreeShipping > 0){
				//$(".free-shipping-counter p").html(`Only <span>$${untilFreeShipping.toFixed(2)}</span> until you get FREE 2-Day Shipping`);
				//$(".free-shipping-counter p").html(`Add one more item in your cart & get FREE Priority Shipping!`);
				$(".free-shipping-counter p").html(`Only <span>$${untilFreeShipping.toFixed(2)}</span> & get FREE Priority Shipping!`);
				$("#shipping-free").text("TBD");
			}
			else{
				$(".free-shipping-counter p").html('Add one more item in your cart & get FREE Priority Shipping!');
				$("#shipping-free").text("TBD");
			}
		}
	}
}

$('.shopify-product-form').submit(function (e) {
	e.preventDefault();
	
	// Check if the submit was triggered by .open-cart button
	// If so, let the .open-cart handler deal with it
	const activeElement = document.activeElement;
	if (activeElement && $(activeElement).hasClass('open-cart')) {
		return false;
	}
	
	// Prevent duplicate submissions
	if (isAddingToCart) {
		return false;
	}
	
	isAddingToCart = true;
	
	$.ajax({
		type: 'POST',
		url: '/cart/add',
		data: $(this).serialize(),
		success: function(response) {
			console.log('Successfully added to cart:', response);
			isAddingToCart = false;
		},
		error: function(error) {
			isAddingToCart = false;
		}
	});
	
	return false;
});

$('#create_customer').submit(function(e) {   	
	document.cookie = 'register_igethi=1; path=/;'; 	
})

$('#contact_form').submit(function(e) {   	
	document.cookie = 'contact_igethi=1; path=/;'; 	
})

function getQueryParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
}

const discountCode = getQueryParameter("discount");
if (discountCode) {
    localStorage.setItem("appliedDiscountCode", discountCode);
    
    // Try to apply to input if cart is open
    setTimeout(() => {
        const codeInput = document.getElementById("code");
        if (codeInput) {
            codeInput.value = discountCode;
            // If cart is open, apply the discount
            if ($('body').hasClass('cart-menu-open')) {
                applyDiscount();
            }
        }
    }, 500);
}

let oldHref = document.location.href;
const bodyElement = document.querySelector("body");
const observer = new MutationObserver(mutations => {
    mutations.forEach(() => {
        if (oldHref !== document.location.href) {
            oldHref = document.location.href;
            const newDiscountCode = getQueryParameter("discount");
            if (newDiscountCode) {
                localStorage.setItem("appliedDiscountCode", newDiscountCode);
                
                // Try to apply to input if cart is open
                setTimeout(() => {
                    const codeInput = document.getElementById("code");
                    if (codeInput) {
                        codeInput.value = newDiscountCode;
                        console.log("Applied discount code to input:", newDiscountCode);
                        // If cart is open, apply the discount
                        if ($('body').hasClass('cart-menu-open')) {
                            applyDiscount();
                        }
                    }
                }, 500);
            }
        }
    });
});

observer.observe(bodyElement, { childList: true, subtree: true });

// Capture discount code from current URL
const currentPath = window.location.pathname;
const discountMatch = currentPath.match(/\/discount\/([^\/]+)/);

if (discountMatch) {
    const discountCodeOld = discountMatch[1];
    sessionStorage.setItem("pendingDiscountCode", discountCodeOld);
}

// Check if there's a pending discount code from redirect
const pendingDiscountCode = sessionStorage.getItem("pendingDiscountCode");
if (pendingDiscountCode) {
    localStorage.setItem("appliedDiscountCode", pendingDiscountCode);
    sessionStorage.removeItem("pendingDiscountCode");
}

// Helper function to check and add BOGO free item immediately
// Check NYE26 promotion: Buy 2 Get 1 Free
async function checkNYE26Promotion(discountCode) {
    const NYE26_PRODUCT_IDS = [7351018749994, 7728722673706];
    
    const codeUpper = discountCode.trim().toUpperCase();
    
    // Only process for NYE26 code
    if (codeUpper !== 'NYE26') {
        return { success: false, message: 'Invalid code' };
    }
    
    try {
        // Get current cart
        const cartResp = await fetch('/cart.js');
        const cart = await cartResp.json();
        
        let totalEligibleItems = 0;
        
        // Count total quantity of eligible products in cart
        cart.items.forEach(function (item) {
            if (NYE26_PRODUCT_IDS.includes(item.product_id)) {
                totalEligibleItems += item.quantity;
            }
        });
        
        // Check if customer has at least 3 items (buy 2 get 1 = minimum 3 items)
        if (totalEligibleItems < 3) {
            const itemsNeeded = 3 - totalEligibleItems;
            return { 
                success: false, 
                message: `Add ${itemsNeeded} more item${itemsNeeded > 1 ? 's' : ''} to activate the promotion` 
            };
        }
        
        // If customer has 3 or more items, promotion is valid
        return { success: true, message: 'Discount Applied!' };
        
    } catch (error) {
        return { success: false, message: 'Error applying discount' };
    }
}

async function checkAndAddBOGOFreeItem(discountCode) {
    const BOGO_PRODUCT_IDS = [7351018749994, 7728722673706];
    const BOGO4PK_VARIANT_ID = 43797319319594;
    const BOGO_FREE_VARIANT_ID = 43797319254058;
    
    const codeUpper = discountCode.trim().toUpperCase();
    
    // Only process for BOGO codes
    if (codeUpper !== 'BOGORP' && codeUpper !== 'BOGO4PK') {
        return { success: false, message: 'Invalid code' };
    }
    
    try {
        // Get current cart
        const cartResp = await fetch('/cart.js');
        const cart = await cartResp.json();
        
        let hasBOGOProduct = false;
        let hasBOGO4PKProduct = false;
        let hasBOGOFreeItem = false;
        
        // Check what's in the cart
        cart.items.forEach(function (item) {
            // Check for BOGORP products (one-time purchase only)
            if (BOGO_PRODUCT_IDS.includes(item.product_id) && !item.hasOwnProperty("selling_plan_allocation")) {
                hasBOGOProduct = true;
            }
            
            // Check for BOGO4PK variant (one-time purchase only)
            if (item.id === BOGO4PK_VARIANT_ID && !item.hasOwnProperty("selling_plan_allocation")) {
                hasBOGO4PKProduct = true;
            }
            
            // Check if free item already exists
            if (item.id === BOGO_FREE_VARIANT_ID) {
                hasBOGOFreeItem = true;
            }
        });
        
        // Validate if required products are in cart
        if (codeUpper === 'BOGORP' && !hasBOGOProduct) {
            return { success: false, message: 'Please add an eligible product to use this promotion.' };
        }
        
        if (codeUpper === 'BOGO4PK' && !hasBOGO4PKProduct) {
            return { success: false, message: 'Please add an eligible product to use this promotion.' };
        }
        
        // Add free item if conditions are met
        if (codeUpper === 'BOGORP' && hasBOGOProduct && !hasBOGOFreeItem) {
            await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: BOGO_FREE_VARIANT_ID,
                    quantity: 1
                })
            });
            return { success: true, message: 'Discount Applied!' };
        } else if (codeUpper === 'BOGO4PK' && hasBOGO4PKProduct && !hasBOGOFreeItem) {
            await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: BOGO_FREE_VARIANT_ID,
                    quantity: 1
                })
            });
            return { success: true, message: 'Discount Applied!' };
        }
        
        // If free item already exists
        return { success: true, message: 'Discount Applied!' };
        
    } catch (error) {
        return { success: false, message: 'Error applying discount' };
    }
}

async function applyDiscount(skipFinalRender = false) {
    // Show shimmer on cart menu
    $("#cart-menu .wrapper").css("opacity", "1");
    addShimmerCart();
  
    // Get current cart to check for existing discounts
    const currentCart = await fetch('/cart.js').then(res => res.json());
    const subTotalOrg = currentCart.items_subtotal_price / 100;
  
    // Get and trim the discount code from the input
    const inp = document.getElementById("code");
    const code = inp.value.trim();
  
    // If no code entered, hide response
    if (!code) {
      localStorage.removeItem("appliedDiscountCode");
      $("#response").hide();
      removeShimmerCart();
      if (!skipFinalRender) {
        fetchCart();
      }
      return;
    }
    
    // Check if there's already a different discount code active
    const activeDiscounts = currentCart.discount_codes?.filter(d => d.applicable) || [];
    const hasDifferentCode = activeDiscounts.length > 0 && 
                              !activeDiscounts.some(d => d.code.toLowerCase() === code.toLowerCase());
    
    if (hasDifferentCode) {
      // Simply apply the new code - let Shopify handle it
      // Note: Shopify may keep the first code active, but we'll show the UI
      localStorage.setItem("appliedDiscountCode", code);
      // Don't return - continue with normal flow
    }
  
    // Special pre-validation for NYE26 before calling Shopify endpoint
    const codeUpperPreCheck = code.trim().toUpperCase();
    if (codeUpperPreCheck === 'NYE26') {
      const preCheckResult = await checkNYE26Promotion(code);
      if (!preCheckResult.success) {
        // Not enough items - show warning message
        $("#response")
          .removeClass("hidden valid error")
          .addClass("warning invalid")
          .show()
          .text(preCheckResult.message);
        
        $(".discountvalue").text("TBD");
        removeShimmerCart();
        if (!skipFinalRender) {
          fetchCart();
        }
        return;
      }
    }
  
    try {
      // Activate the discount by requesting the special endpoint
      const resp1 = await fetch(`/discount/${encodeURIComponent(code)}`);
      if (!resp1.ok) throw new Error("Invalid discount code");
  
      // 3) Force cart recalculation without changing any items
      const resp2 = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: {} })
      });
      const cart = await resp2.json();
      
      // Check which code is actually active
      const nowActiveDiscounts = cart.discount_codes?.filter(d => d.applicable) || [];
      const requestedCodeIsActive = nowActiveDiscounts.some(d => d.code.toLowerCase() === code.toLowerCase());
  
      const newTotal = cart.total_price / 100;
      const discountApplied = cart.total_discount > 0;
  
      if (discountApplied && requestedCodeIsActive) {
        // Requested code is active - success!
        localStorage.setItem("appliedDiscountCode", code);
  
        $("#response")
          .removeClass("hidden error invalid")
          .addClass("valid")
          .show()
          .text("Discount Applied!");
        
        if (code !== 'freeship1' && code.toUpperCase() !== 'FREESHIP' && code.toUpperCase() !== 'SHIPCHERRY' && code.toUpperCase() !== 'SHIP10MG') {
          // Calculate and display discount amount
          const calcDiscount = cart.total_discount / 100;
          $(".discountvalue").text("$" + calcDiscount.toFixed(2));
        }
      } else if (discountApplied && !requestedCodeIsActive) {
        // Different code is active
        const activeCode = nowActiveDiscounts[0]?.code || 'unknown';
        
        $("#response")
          .removeClass("hidden valid error")
          .addClass("warning invalid")
          .show()
          .html(`Code <strong>${activeCode}</strong> is already applied. To use a different code, please go to <a target="_blank" href="/checkout" style="text-decoration:underline;color:inherit;">checkout</a> and remove it first.`);
      } else if (discountApplied) {
        // Some discount applied but can't determine which
        localStorage.setItem("appliedDiscountCode", code);
  
        $("#response")
          .removeClass("hidden error invalid")
          .addClass("valid")
          .show()
          .text("Discount Applied!");
  
        if (code !== 'freeship1') {
          // Calculate and display discount amount
          const calcDiscount = cart.total_discount / 100;
          $(".discountvalue").text("$" + calcDiscount.toFixed(2));
        }
        
        // Cart will be re-rendered in finally block
  
      } else {
		const codeUpper = code.trim().toUpperCase();
		
		if (codeUpper === 'FREESHIP' || codeUpper === 'SHIPCHERRY' || codeUpper === 'SHIP10MG') {
			localStorage.setItem("appliedDiscountCode", code);
			//$(".free-shipping-counter p").html('Congratulations! You got <span>FREE</span> shipping.');
           	$("#response")
				.removeClass("hidden error invalid")
				.addClass("valid")
				.show()
				.text("Discount Applied!");
			
			// Cart will be re-rendered in finally block
				
		} else if (codeUpper === 'NYE26') {
			// Special handling for NYE26 code (Buy 2 Get 1 Free)
			
			// Check if customer has enough items for the promotion
			const result = await checkNYE26Promotion(code);
			
			if (result.success) {
				localStorage.setItem("appliedDiscountCode", code);
				
				$("#response")
					.removeClass("hidden error invalid")
					.addClass("valid")
					.show()
					.text(result.message);
				
				// Show discount value if Shopify applied the discount
				const calcDiscount = cart.total_discount / 100;
				if (calcDiscount > 0) {
					$(".discountvalue").text("$" + calcDiscount.toFixed(2));
				} else {
					$(".discountvalue").text("TBD");
				}
				
				// Cart will be re-rendered in finally block
			} else {
				// Not enough items - show message
				$("#response")
					.removeClass("hidden valid error")
					.addClass("warning invalid")
					.show()
					.text(result.message);
				
				$(".discountvalue").text("TBD");
				
				// Cart will be re-rendered in finally block
			}
			
		} else if (codeUpper === 'BOGORP' || codeUpper === 'BOGO4PK') {
			// Special handling for BOGO codes that don't exist in Shopify
			
			// Add BOGO free item immediately before showing success message
			const result = await checkAndAddBOGOFreeItem(code);
			
			if (result.success) {
				localStorage.setItem("appliedDiscountCode", code);
				
				$("#response")
					.removeClass("hidden error invalid")
					.addClass("valid")
					.show()
					.text(result.message);
				
				$(".discountvalue").text("TBD");
				
				// Cart will be re-rendered in finally block
			} else {
				// Product not in cart - show error message
				$("#response")
					.removeClass("hidden valid")
					.addClass("error invalid")
					.show()
					.text(result.message);
				
				$(".discountvalue").text("TBD");
				
				// Cart will be re-rendered in finally block
			}
			
        } else {
			// Handle case where code was rejected
			if (codeUpper === 'BOGO') {
				// Special handling for BOGO coupon
				$("#response")
				.removeClass("hidden valid error")
				.addClass("warning invalid")
				.show()
				.text("Add one more item to get a free one.");
			} else {
				// Default error message for other invalid codes
				$("#response")
				.removeClass("hidden valid")
				.addClass("error invalid")
				.show()
				.text("Please Enter Valid Coupon Code.");
			}
			
			$(".discountvalue").text("TBD");
			
			// Cart will be re-rendered in finally block
		}
      }
  
    } catch (error) {
      const codeUpper = code.trim().toUpperCase();
      
      // Special handling for NYE26 code (Buy 2 Get 1 Free)
      if (codeUpper === 'NYE26') {
        // Check if customer has enough items for the promotion
        const result = await checkNYE26Promotion(code);
        
        if (result.success) {
          localStorage.setItem("appliedDiscountCode", code);
          
          $("#response")
            .removeClass("hidden error invalid")
            .addClass("valid")
            .show()
            .text(result.message);
          
          // Try to get cart and show discount value if available
          try {
            const cartResp = await fetch('/cart.js');
            const cart = await cartResp.json();
            const calcDiscount = cart.total_discount / 100;
            if (calcDiscount > 0) {
              $(".discountvalue").text("$" + calcDiscount.toFixed(2));
            } else {
              $(".discountvalue").text("TBD");
            }
          } catch {
            $(".discountvalue").text("TBD");
          }
          
          // Cart will be re-rendered in finally block
        } else {
          // Not enough items - show message
          $("#response")
            .removeClass("hidden valid error")
            .addClass("warning invalid")
            .show()
            .text(result.message);
          
          $(".discountvalue").text("TBD");
          
          // Cart will be re-rendered in finally block
        }
        
      } else if (codeUpper === 'BOGORP' || codeUpper === 'BOGO4PK') {
        // Special handling for BOGO codes that don't exist in Shopify
        // Add BOGO free item immediately before showing success message
        const result = await checkAndAddBOGOFreeItem(code);
        
        if (result.success) {
          // Save the code to localStorage so it can be used by cart logic
          localStorage.setItem("appliedDiscountCode", code);
          
          $("#response")
            .removeClass("hidden error invalid")
            .addClass("valid")
            .show()
            .text(result.message);
          
          $(".discountvalue").text("TBD");
          
          // Cart will be re-rendered in finally block
        } else {
          // Product not in cart - show error message
          $("#response")
            .removeClass("hidden valid")
            .addClass("error invalid")
            .show()
            .text(result.message);
          
          $(".discountvalue").text("TBD");
          
          // Cart will be re-rendered in finally block
        }
        
      } else if (codeUpper === 'BOGO') {
        // Special handling for BOGO coupon
        $("#response")
          .removeClass("hidden valid error")
          .addClass("warning invalid")
          .show()
          .text("Add one more item to get a free one.");
        
        $(".discountvalue").text("TBD");
        
        // Cart will be re-rendered in finally block
        
      } else {
        // Default error message for other invalid codes
        $("#response")
          .removeClass("hidden valid")
          .addClass("error invalid")
          .show()
          .text("Please Enter Valid Coupon Code.");
        
        $(".discountvalue").text("TBD");
        
        // Cart will be re-rendered in finally block
      }
  
    } finally {
      // Always restore UI state and refresh cart only if not being called from another render function
      $("#cart-menu .wrapper").css("opacity", "1");
      removeShimmerCart();
      if (!skipFinalRender) {
        fetchCart();
      }
    }
}

// Function to capture discount code from URL
function captureDiscountCode() {
    // Try to get from URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    let discountCode = urlParams.get('discount');

    // If not in URL params, try to get from path
    if (!discountCode) {
        const pathMatch = window.location.pathname.match(/\/discount\/([^\/]+)/);
        if (pathMatch) {
            discountCode = pathMatch[1];
        }
    }

    // If not in path, try to get from referrer
    if (!discountCode) {
        const referrer = document.referrer;
        if (referrer) {
            const referrerUrl = new URL(referrer);
            const referrerMatch = referrerUrl.pathname.match(/\/discount\/([^\/]+)/);
            if (referrerMatch) {
                discountCode = referrerMatch[1];
            }
        }
    }

    // If we found a discount code, save it
    if (discountCode) {
        localStorage.setItem("appliedDiscountCode", discountCode);
        sessionStorage.setItem("pendingDiscountCode", discountCode);
    }
}

// Run on page load
document.addEventListener('DOMContentLoaded', captureDiscountCode);

// Run on history changes (for SPA navigation)
window.addEventListener('popstate', captureDiscountCode);

// Run immediately in case we're too late for DOMContentLoaded
captureDiscountCode();
  

function banner_countdown() {
    // countdown
    setTimeout(function () {
        var start_date = new Date("Apr 30, 2024 08:00:01 UTC-4").getTime();
        var stop_date = new Date("May 10 2026 08:00:01 UTC-4").getTime();

        var cInterval = setInterval(function () {
            let now = new Date().getTime();

            // Check if current time is before start date or after stop date
            if (now < start_date || now > stop_date) {
                $('.countbanner').fadeOut();
                if (now > stop_date) {
                    $('.counter .days').text("00");
                    $('.counter .hours').text("00");
                    $('.counter .minutes').text("00");
                }
                return false;
            }

            // Show banner if we're between start and stop dates
            if (!$('.countbanner').is(':visible')) {
                $('.countbanner').fadeIn();
            }

            let distance = stop_date - now;

            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor(distance / (1000 * 60 * 60)); //only hours
            var minutes = ('0' + Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).substr(-2);
            var seconds = ('0' + Math.floor((distance % (1000 * 60)) / 1000)).substr(-2);

            if (distance < 0) {
                clearInterval(cInterval);
            }

            if (days < 10) {
                $('.counter .days').text("0" + days);
            }
            else {
                $('.counter .days').text(days);
            }

            $('.counter .hours').text(hours);
            $('.counter .minutes').text(minutes);
            $('.counter .seconds').text(seconds);

        }, 1000);

    }, 1000);
}

// constants
const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// pubsub
let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

// global
function getFocusableElements(container) {
	return Array.from(
	  container.querySelectorAll(
		"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
	  )
	);
  }
  
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute('role', 'button');
	summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  
	if (summary.nextElementSibling.getAttribute('id')) {
	  summary.setAttribute('aria-controls', summary.nextElementSibling.id);
	}
  
	summary.addEventListener('click', (event) => {
	  event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
	});
  
	if (summary.closest('header-drawer, menu-drawer')) return;
	summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  });
  
  const trapFocusHandlers = {};
  
  function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container);
	var first = elements[0];
	var last = elements[elements.length - 1];
  
	removeTrapFocus();
  
	trapFocusHandlers.focusin = (event) => {
	  if (event.target !== container && event.target !== last && event.target !== first) return;
  
	  document.addEventListener('keydown', trapFocusHandlers.keydown);
	};
  
	trapFocusHandlers.focusout = function () {
	  document.removeEventListener('keydown', trapFocusHandlers.keydown);
	};
  
	trapFocusHandlers.keydown = function (event) {
	  if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
	  // On the last focusable element and tab forward, focus the first element.
	  if (event.target === last && !event.shiftKey) {
		event.preventDefault();
		first.focus();
	  }
  
	  //  On the first focusable element and tab backward, focus the last element.
	  if ((event.target === container || event.target === first) && event.shiftKey) {
		event.preventDefault();
		last.focus();
	  }
	};
  
	document.addEventListener('focusout', trapFocusHandlers.focusout);
	document.addEventListener('focusin', trapFocusHandlers.focusin);
  
	elementToFocus.focus();
  
	if (
	  elementToFocus.tagName === 'INPUT' &&
	  ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
	  elementToFocus.value
	) {
	  elementToFocus.setSelectionRange(0, elementToFocus.value.length);
	}
  }
  
  // Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
  try {
	document.querySelector(':focus-visible');
  } catch (e) {
	focusVisiblePolyfill();
  }
  
  function focusVisiblePolyfill() {
	const navKeys = [
	  'ARROWUP',
	  'ARROWDOWN',
	  'ARROWLEFT',
	  'ARROWRIGHT',
	  'TAB',
	  'ENTER',
	  'SPACE',
	  'ESCAPE',
	  'HOME',
	  'END',
	  'PAGEUP',
	  'PAGEDOWN',
	];
	let currentFocusedElement = null;
	let mouseClick = null;
  
	window.addEventListener('keydown', (event) => {
	  if (navKeys.includes(event.code.toUpperCase())) {
		mouseClick = false;
	  }
	});
  
	window.addEventListener('mousedown', (event) => {
	  mouseClick = true;
	});
  
	window.addEventListener(
	  'focus',
	  () => {
		if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
  
		if (mouseClick) return;
  
		currentFocusedElement = document.activeElement;
		currentFocusedElement.classList.add('focused');
	  },
	  true
	);
  }
  
  function pauseAllMedia() {
	document.querySelectorAll('.js-youtube').forEach((video) => {
	  video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
	});
	document.querySelectorAll('.js-vimeo').forEach((video) => {
	  video.contentWindow.postMessage('{"method":"pause"}', '*');
	});
	document.querySelectorAll('video').forEach((video) => video.pause());
	document.querySelectorAll('product-model').forEach((model) => {
	  if (model.modelViewerUI) model.modelViewerUI.pause();
	});
  }
  
  function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener('focusin', trapFocusHandlers.focusin);
	document.removeEventListener('focusout', trapFocusHandlers.focusout);
	document.removeEventListener('keydown', trapFocusHandlers.keydown);
  
	if (elementToFocus) elementToFocus.focus();
  }
  
  function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== 'ESCAPE') return;
  
	const openDetailsElement = event.target.closest('details[open]');
	if (!openDetailsElement) return;
  
	const summaryElement = openDetailsElement.querySelector('summary');
	openDetailsElement.removeAttribute('open');
	summaryElement.setAttribute('aria-expanded', false);
	summaryElement.focus();
  }
  
  class QuantityInput extends HTMLElement {
	constructor() {
	  super();
	  this.input = this.querySelector('input');
	  this.changeEvent = new Event('change', { bubbles: true });
	  this.input.addEventListener('change', this.onInputChange.bind(this));
	  this.querySelectorAll('button').forEach((button) =>
		button.addEventListener('click', this.onButtonClick.bind(this))
	  );
	}
  
	quantityUpdateUnsubscriber = undefined;
  
	connectedCallback() {
	  this.validateQtyRules();
	  this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
	}
  
	disconnectedCallback() {
	  if (this.quantityUpdateUnsubscriber) {
		this.quantityUpdateUnsubscriber();
	  }
	}
  
	onInputChange(event) {
	  this.validateQtyRules();
	}
  
	onButtonClick(event) {
	  event.preventDefault();
	  const previousValue = this.input.value;
  
	  if (event.target.name === 'plus') {
		if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
		  this.input.value = this.input.dataset.min;
		} else {
		  this.input.stepUp();
		}
	  } else {
		this.input.stepDown();
	  }
  
	  if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  
	  if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
		this.input.value = parseInt(this.input.min);
	  }
	}
  
	validateQtyRules() {
	  const value = parseInt(this.input.value);
	  if (this.input.min) {
		const buttonMinus = this.querySelector(".quantity__button[name='minus']");
		buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
	  }
	  if (this.input.max) {
		const max = parseInt(this.input.max);
		const buttonPlus = this.querySelector(".quantity__button[name='plus']");
		buttonPlus.classList.toggle('disabled', value >= max);
	  }
	}
  }
  
  customElements.define('quantity-input', QuantityInput);
  
  function debounce(fn, wait) {
	let t;
	return (...args) => {
	  clearTimeout(t);
	  t = setTimeout(() => fn.apply(this, args), wait);
	};
  }
  
  function throttle(fn, delay) {
	let lastCall = 0;
	return function (...args) {
	  const now = new Date().getTime();
	  if (now - lastCall < delay) {
		return;
	  }
	  lastCall = now;
	  return fn(...args);
	};
  }
  
  function fetchConfig(type = 'json') {
	return {
	  method: 'POST',
	  headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
	};
  }
  
  /*
   * Shopify Common JS
   *
   */
  if (typeof window.Shopify == 'undefined') {
	window.Shopify = {};
  }
  
  Shopify.bind = function (fn, scope) {
	return function () {
	  return fn.apply(scope, arguments);
	};
  };
  
  Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
	  var option = selector.options[i];
	  if (value == option.value || value == option.innerHTML) {
		selector.selectedIndex = i;
		return i;
	  }
	}
  };
  
  Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
	  ? target.addEventListener(eventName, callback, false)
	  : target.attachEvent('on' + eventName, callback);
  };
  
  Shopify.postLink = function (path, options) {
	options = options || {};
	var method = options['method'] || 'post';
	var params = options['parameters'] || {};
  
	var form = document.createElement('form');
	form.setAttribute('method', method);
	form.setAttribute('action', path);
  
	for (var key in params) {
	  var hiddenField = document.createElement('input');
	  hiddenField.setAttribute('type', 'hidden');
	  hiddenField.setAttribute('name', key);
	  hiddenField.setAttribute('value', params[key]);
	  form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
  };
  
  Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  
	Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
  
	this.initCountry();
	this.initProvince();
  };
  
  Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
	  var value = this.countryEl.getAttribute('data-default');
	  Shopify.setSelectorByValue(this.countryEl, value);
	  this.countryHandler();
	},
  
	initProvince: function () {
	  var value = this.provinceEl.getAttribute('data-default');
	  if (value && this.provinceEl.options.length > 0) {
		Shopify.setSelectorByValue(this.provinceEl, value);
	  }
	},
  
	countryHandler: function (e) {
	  var opt = this.countryEl.options[this.countryEl.selectedIndex];
	  var raw = opt.getAttribute('data-provinces');
	  var provinces = JSON.parse(raw);
  
	  this.clearOptions(this.provinceEl);
	  if (provinces && provinces.length == 0) {
		this.provinceContainer.style.display = 'none';
	  } else {
		for (var i = 0; i < provinces.length; i++) {
		  var opt = document.createElement('option');
		  opt.value = provinces[i][0];
		  opt.innerHTML = provinces[i][1];
		  this.provinceEl.appendChild(opt);
		}
  
		this.provinceContainer.style.display = '';
	  }
	},
  
	clearOptions: function (selector) {
	  while (selector.firstChild) {
		selector.removeChild(selector.firstChild);
	  }
	},
  
	setOptions: function (selector, values) {
	  for (var i = 0, count = values.length; i < values.length; i++) {
		var opt = document.createElement('option');
		opt.value = values[i];
		opt.innerHTML = values[i];
		selector.appendChild(opt);
	  }
	},
  };
  
  class MenuDrawer extends HTMLElement {
	constructor() {
	  super();
  
	  this.mainDetailsToggle = this.querySelector('details');
  
	  this.addEventListener('keyup', this.onKeyUp.bind(this));
	  this.addEventListener('focusout', this.onFocusOut.bind(this));
	  this.bindEvents();
	}
  
	bindEvents() {
	  this.querySelectorAll('summary').forEach((summary) =>
		summary.addEventListener('click', this.onSummaryClick.bind(this))
	  );
	  this.querySelectorAll(
		'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
	  ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
	}
  
	onKeyUp(event) {
	  if (event.code.toUpperCase() !== 'ESCAPE') return;
  
	  const openDetailsElement = event.target.closest('details[open]');
	  if (!openDetailsElement) return;
  
	  openDetailsElement === this.mainDetailsToggle
		? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
		: this.closeSubmenu(openDetailsElement);
	}
  
	onSummaryClick(event) {
	  const summaryElement = event.currentTarget;
	  const detailsElement = summaryElement.parentNode;
	  const parentMenuElement = detailsElement.closest('.has-submenu');
	  const isOpen = detailsElement.hasAttribute('open');
	  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  
	  function addTrapFocus() {
		trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
		summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
	  }
  
	  if (detailsElement === this.mainDetailsToggle) {
		if (isOpen) event.preventDefault();
		isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
  
		if (window.matchMedia('(max-width: 990px)')) {
		  document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
		}
	  } else {
		setTimeout(() => {
		  detailsElement.classList.add('menu-opening');
		  summaryElement.setAttribute('aria-expanded', true);
		  parentMenuElement && parentMenuElement.classList.add('submenu-open');
		  !reducedMotion || reducedMotion.matches
			? addTrapFocus()
			: summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
		}, 100);
	  }
	}
  
	openMenuDrawer(summaryElement) {
	  setTimeout(() => {
		this.mainDetailsToggle.classList.add('menu-opening');
	  });
	  summaryElement.setAttribute('aria-expanded', true);
	  trapFocus(this.mainDetailsToggle, summaryElement);
	  document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}
  
	closeMenuDrawer(event, elementToFocus = false) {
	  if (event === undefined) return;
  
	  this.mainDetailsToggle.classList.remove('menu-opening');
	  this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
		details.removeAttribute('open');
		details.classList.remove('menu-opening');
	  });
	  this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
		submenu.classList.remove('submenu-open');
	  });
	  document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
	  removeTrapFocus(elementToFocus);
	  this.closeAnimation(this.mainDetailsToggle);
  
	  if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
	}
  
	onFocusOut() {
	  setTimeout(() => {
		if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
		  this.closeMenuDrawer();
	  });
	}
  
	onCloseButtonClick(event) {
	  const detailsElement = event.currentTarget.closest('details');
	  this.closeSubmenu(detailsElement);
	}
  
	closeSubmenu(detailsElement) {
	  const parentMenuElement = detailsElement.closest('.submenu-open');
	  parentMenuElement && parentMenuElement.classList.remove('submenu-open');
	  detailsElement.classList.remove('menu-opening');
	  detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
	  removeTrapFocus(detailsElement.querySelector('summary'));
	  this.closeAnimation(detailsElement);
	}
  
	closeAnimation(detailsElement) {
	  let animationStart;
  
	  const handleAnimation = (time) => {
		if (animationStart === undefined) {
		  animationStart = time;
		}
  
		const elapsedTime = time - animationStart;
  
		if (elapsedTime < 400) {
		  window.requestAnimationFrame(handleAnimation);
		} else {
		  detailsElement.removeAttribute('open');
		  if (detailsElement.closest('details[open]')) {
			trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
		  }
		}
	  };
  
	  window.requestAnimationFrame(handleAnimation);
	}
  }
  
  customElements.define('menu-drawer', MenuDrawer);
  
  class HeaderDrawer extends MenuDrawer {
	constructor() {
	  super();
	}
  
	openMenuDrawer(summaryElement) {
	  this.header = this.header || document.querySelector('.section-header');
	  this.borderOffset =
		this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
	  document.documentElement.style.setProperty(
		'--header-bottom-position',
		`${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
	  );
	  this.header.classList.add('menu-open');
  
	  setTimeout(() => {
		this.mainDetailsToggle.classList.add('menu-opening');
	  });
  
	  summaryElement.setAttribute('aria-expanded', true);
	  window.addEventListener('resize', this.onResize);
	  trapFocus(this.mainDetailsToggle, summaryElement);
	  document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}
  
	closeMenuDrawer(event, elementToFocus) {
	  if (!elementToFocus) return;
	  super.closeMenuDrawer(event, elementToFocus);
	  this.header.classList.remove('menu-open');
	  window.removeEventListener('resize', this.onResize);
	}
  
	onResize = () => {
	  this.header &&
		document.documentElement.style.setProperty(
		  '--header-bottom-position',
		  `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
		);
	  document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
	};
  }
  
  customElements.define('header-drawer', HeaderDrawer);
  
  class ModalDialog extends HTMLElement {
	constructor() {
	  super();
	  this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
	  this.addEventListener('keyup', (event) => {
		if (event.code.toUpperCase() === 'ESCAPE') this.hide();
	  });
	  if (this.classList.contains('media-modal')) {
		this.addEventListener('pointerup', (event) => {
		  if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
		});
	  } else {
		this.addEventListener('click', (event) => {
		  if (event.target === this) this.hide();
		});
	  }
	}
  
	connectedCallback() {
	  if (this.moved) return;
	  this.moved = true;
	  document.body.appendChild(this);
	}
  
	show(opener) {
	  this.openedBy = opener;
	  const popup = this.querySelector('.template-popup');
	  document.body.classList.add('overflow-hidden');
	  this.setAttribute('open', '');
	  if (popup) popup.loadContent();
	  trapFocus(this, this.querySelector('[role="dialog"]'));
	  window.pauseAllMedia();
	}
  
	hide() {
	  document.body.classList.remove('overflow-hidden');
	  document.body.dispatchEvent(new CustomEvent('modalClosed'));
	  this.removeAttribute('open');
	  removeTrapFocus(this.openedBy);
	  window.pauseAllMedia();
	}
  }
  customElements.define('modal-dialog', ModalDialog);
  
  class ModalOpener extends HTMLElement {
	constructor() {
	  super();
  
	  const button = this.querySelector('button');
  
	  if (!button) return;
	  button.addEventListener('click', () => {
		const modal = document.querySelector(this.getAttribute('data-modal'));
		if (modal) modal.show(button);
	  });
	}
  }
  customElements.define('modal-opener', ModalOpener);
  
  class DeferredMedia extends HTMLElement {
	constructor() {
	  super();
	  const poster = this.querySelector('[id^="Deferred-Poster-"]');
	  if (!poster) return;
	  poster.addEventListener('click', this.loadContent.bind(this));
	}
  
	loadContent(focus = true) {
	  window.pauseAllMedia();
	  if (!this.getAttribute('loaded')) {
		const content = document.createElement('div');
		content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
  
		this.setAttribute('loaded', true);
		const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
		if (focus) deferredElement.focus();
		if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
		  // force autoplay for safari
		  deferredElement.play();
		}
	  }
	}
  }
  
  customElements.define('deferred-media', DeferredMedia);
  
  class SliderComponent extends HTMLElement {
	constructor() {
	  super();
	  this.slider = this.querySelector('[id^="Slider-"]');
	  this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
	  this.enableSliderLooping = false;
	  this.currentPageElement = this.querySelector('.slider-counter--current');
	  this.pageTotalElement = this.querySelector('.slider-counter--total');
	  this.prevButton = this.querySelector('button[name="previous"]');
	  this.nextButton = this.querySelector('button[name="next"]');
  
	  if (!this.slider || !this.nextButton) return;
  
	  this.initPages();
	  const resizeObserver = new ResizeObserver((entries) => this.initPages());
	  resizeObserver.observe(this.slider);
  
	  this.slider.addEventListener('scroll', this.update.bind(this));
	  this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
	  this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
	}
  
	initPages() {
	  this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
	  if (this.sliderItemsToShow.length < 2) return;
	  this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
	  this.slidesPerPage = Math.floor(
		(this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
	  );
	  this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
	  this.update();
	}
  
	resetPages() {
	  this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
	  this.initPages();
	}
  
	update() {
	  // Temporarily prevents unneeded updates resulting from variant changes
	  // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
	  if (!this.slider || !this.nextButton) return;
  
	  const previousPage = this.currentPage;
	  this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
  
	  if (this.currentPageElement && this.pageTotalElement) {
		this.currentPageElement.textContent = this.currentPage;
		this.pageTotalElement.textContent = this.totalPages;
	  }
  
	  if (this.currentPage != previousPage) {
		this.dispatchEvent(
		  new CustomEvent('slideChanged', {
			detail: {
			  currentPage: this.currentPage,
			  currentElement: this.sliderItemsToShow[this.currentPage - 1],
			},
		  })
		);
	  }
  
	  if (this.enableSliderLooping) return;
  
	  if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
		this.prevButton.setAttribute('disabled', 'disabled');
	  } else {
		this.prevButton.removeAttribute('disabled');
	  }
  
	  if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
		this.nextButton.setAttribute('disabled', 'disabled');
	  } else {
		this.nextButton.removeAttribute('disabled');
	  }
	}
  
	isSlideVisible(element, offset = 0) {
	  const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
	  return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
	}
  
	onButtonClick(event) {
	  event.preventDefault();
	  const step = event.currentTarget.dataset.step || 1;
	  this.slideScrollPosition =
		event.currentTarget.name === 'next'
		  ? this.slider.scrollLeft + step * this.sliderItemOffset
		  : this.slider.scrollLeft - step * this.sliderItemOffset;
	  this.setSlidePosition(this.slideScrollPosition);
	}
  
	setSlidePosition(position) {
	  this.slider.scrollTo({
		left: position,
	  });
	}
  }
  
  customElements.define('slider-component', SliderComponent);
  
  class SlideshowComponent extends SliderComponent {
	constructor() {
	  super();
	  this.sliderControlWrapper = this.querySelector('.slider-buttons');
	  this.enableSliderLooping = true;
  
	  if (!this.sliderControlWrapper) return;
  
	  this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
	  if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
  
	  this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
	  // Value below should match --duration-announcement-bar CSS value
	  this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;
  
	  this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
	  this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
	  this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
	  this.setSlideVisibility();
  
	  if (this.announcementBarSlider) {
		this.announcementBarArrowButtonWasClicked = false;
  
		this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
		this.reducedMotion.addEventListener('change', () => {
		  if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
		});
  
		[this.prevButton, this.nextButton].forEach((button) => {
		  button.addEventListener(
			'click',
			() => {
			  this.announcementBarArrowButtonWasClicked = true;
			},
			{ once: true }
		  );
		});
	  }
  
	  if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
	}
  
	setAutoPlay() {
	  this.autoplaySpeed = this.slider.dataset.speed * 1000;
	  this.addEventListener('mouseover', this.focusInHandling.bind(this));
	  this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
	  this.addEventListener('focusin', this.focusInHandling.bind(this));
	  this.addEventListener('focusout', this.focusOutHandling.bind(this));
  
	  if (this.querySelector('.slideshow__autoplay')) {
		this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
		this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
		this.autoplayButtonIsSetToPlay = true;
		this.play();
	  } else {
		this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
	  }
	}
  
	onButtonClick(event) {
	  super.onButtonClick(event);
	  this.wasClicked = true;
  
	  const isFirstSlide = this.currentPage === 1;
	  const isLastSlide = this.currentPage === this.sliderItemsToShow.length;
  
	  if (!isFirstSlide && !isLastSlide) {
		this.applyAnimationToAnnouncementBar(event.currentTarget.name);
		return;
	  }
  
	  if (isFirstSlide && event.currentTarget.name === 'previous') {
		this.slideScrollPosition =
		  this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
	  } else if (isLastSlide && event.currentTarget.name === 'next') {
		this.slideScrollPosition = 0;
	  }
  
	  this.setSlidePosition(this.slideScrollPosition);
  
	  this.applyAnimationToAnnouncementBar(event.currentTarget.name);
	}
  
	setSlidePosition(position) {
	  if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
	  this.setPositionTimeout = setTimeout(() => {
		this.slider.scrollTo({
		  left: position,
		});
	  }, this.announcerBarAnimationDelay);
	}
  
	update() {
	  super.update();
	  this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
	  this.prevButton.removeAttribute('disabled');
  
	  if (!this.sliderControlButtons.length) return;
  
	  this.sliderControlButtons.forEach((link) => {
		link.classList.remove('slider-counter__link--active');
		link.removeAttribute('aria-current');
	  });
	  this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
	  this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
	}
  
	autoPlayToggle() {
	  this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
	  this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
	  this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
	}
  
	focusOutHandling(event) {
	  if (this.sliderAutoplayButton) {
		const focusedOnAutoplayButton =
		  event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
		if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
		this.play();
	  } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
		this.play();
	  }
	}
  
	focusInHandling(event) {
	  if (this.sliderAutoplayButton) {
		const focusedOnAutoplayButton =
		  event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
		if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
		  this.play();
		} else if (this.autoplayButtonIsSetToPlay) {
		  this.pause();
		}
	  } else if (this.announcementBarSlider.contains(event.target)) {
		this.pause();
	  }
	}
  
	play() {
	  this.slider.setAttribute('aria-live', 'off');
	  clearInterval(this.autoplay);
	  this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
	}
  
	pause() {
	  this.slider.setAttribute('aria-live', 'polite');
	  clearInterval(this.autoplay);
	}
  
	togglePlayButtonState(pauseAutoplay) {
	  if (pauseAutoplay) {
		this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
		this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
	  } else {
		this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
		this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
	  }
	}
  
	autoRotateSlides() {
	  const slideScrollPosition =
		this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;
  
	  this.setSlidePosition(slideScrollPosition);
	  this.applyAnimationToAnnouncementBar();
	}
  
	setSlideVisibility(event) {
	  this.sliderItemsToShow.forEach((item, index) => {
		const linkElements = item.querySelectorAll('a');
		if (index === this.currentPage - 1) {
		  if (linkElements.length)
			linkElements.forEach((button) => {
			  button.removeAttribute('tabindex');
			});
		  item.setAttribute('aria-hidden', 'false');
		  item.removeAttribute('tabindex');
		} else {
		  if (linkElements.length)
			linkElements.forEach((button) => {
			  button.setAttribute('tabindex', '-1');
			});
		  item.setAttribute('aria-hidden', 'true');
		  item.setAttribute('tabindex', '-1');
		}
	  });
	  this.wasClicked = false;
	}
  
	applyAnimationToAnnouncementBar(button = 'next') {
	  if (!this.announcementBarSlider) return;
  
	  const itemsCount = this.sliderItems.length;
	  const increment = button === 'next' ? 1 : -1;
  
	  const currentIndex = this.currentPage - 1;
	  let nextIndex = (currentIndex + increment) % itemsCount;
	  nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;
  
	  const nextSlide = this.sliderItems[nextIndex];
	  const currentSlide = this.sliderItems[currentIndex];
  
	  const animationClassIn = 'announcement-bar-slider--fade-in';
	  const animationClassOut = 'announcement-bar-slider--fade-out';
  
	  const isFirstSlide = currentIndex === 0;
	  const isLastSlide = currentIndex === itemsCount - 1;
  
	  const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
	  const direction = shouldMoveNext ? 'next' : 'previous';
  
	  currentSlide.classList.add(`${animationClassOut}-${direction}`);
	  nextSlide.classList.add(`${animationClassIn}-${direction}`);
  
	  setTimeout(() => {
		currentSlide.classList.remove(`${animationClassOut}-${direction}`);
		nextSlide.classList.remove(`${animationClassIn}-${direction}`);
	  }, this.announcerBarAnimationDelay * 2);
	}
  
	linkToSlide(event) {
	  event.preventDefault();
	  const slideScrollPosition =
		this.slider.scrollLeft +
		this.sliderFirstItemNode.clientWidth *
		  (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
	  this.slider.scrollTo({
		left: slideScrollPosition,
	  });
	}
  }
  
  customElements.define('slideshow-component', SlideshowComponent);
  
  class VariantSelects extends HTMLElement {
	constructor() {
	  super();
	  this.addEventListener('change', this.onVariantChange);
	}
  
	onVariantChange(event) {
	  this.updateOptions();
	  this.updateMasterId();
	  this.updateSelectedSwatchValue(event);
	  this.toggleAddButton(true, '', false);
	  this.updatePickupAvailability();
	  this.removeErrorMessage();
	  this.updateVariantStatuses();
  
	  if (!this.currentVariant) {
		this.toggleAddButton(true, '', true);
		this.setUnavailable();
	  } else {
		this.updateURL();
		this.updateVariantInput();
		this.renderProductInfo();
		this.updateShareUrl();
	  }
	}
  
	updateOptions() {
	  this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
		if (element.tagName === 'SELECT') {
		  return element.value;
		}
		if (element.tagName === 'FIELDSET') {
		  return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
		}
	  });
	}
  
	updateMasterId() {
	  this.currentVariant = this.getVariantData().find((variant) => {
		return !variant.options
		  .map((option, index) => {
			return this.options[index] === option;
		  })
		  .includes(false);
	  });
	}
  
	updateSelectedSwatchValue({ target }) {
	  const { name, value, tagName } = target;
  
	  if (tagName === 'SELECT' && target.selectedOptions.length) {
		const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
		const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
		if (!selectedDropdownSwatchValue) return;
		if (swatchValue) {
		  selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
		  selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
		} else {
		  selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
		  selectedDropdownSwatchValue.classList.add('swatch--unavailable');
		}
  
		selectedDropdownSwatchValue.style.setProperty(
		  '--swatch-focal-point',
		  target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
		);
	  } else if (tagName === 'INPUT' && target.type === 'radio') {
		const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
		if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
	  }
	}
  
	updateURL() {
	  if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
	  window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}
  
	updateShareUrl() {
	  const shareButton = document.getElementById(`Share-${this.dataset.section}`);
	  if (!shareButton || !shareButton.updateUrl) return;
	  shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
	}
  
	updateVariantInput() {
	  const productForms = document.querySelectorAll(
		`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
	  );
	  productForms.forEach((productForm) => {
		const input = productForm.querySelector('input[name="id"]');
		input.value = this.currentVariant.id;
		input.dispatchEvent(new Event('change', { bubbles: true }));
	  });
	}
  
	updateVariantStatuses() {
	  const selectedOptionOneVariants = this.variantData.filter(
		(variant) => this.querySelector(':checked').value === variant.option1
	  );
	  const inputWrappers = [...this.querySelectorAll('.product-form__input')];
	  inputWrappers.forEach((option, index) => {
		if (index === 0) return;
		const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
		const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
		const availableOptionInputsValue = selectedOptionOneVariants
		  .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
		  .map((variantOption) => variantOption[`option${index + 1}`]);
		this.setInputAvailability(optionInputs, availableOptionInputsValue);
	  });
	}
  
	setInputAvailability(elementList, availableValuesList) {
	  elementList.forEach((element) => {
		const value = element.getAttribute('value');
		const availableElement = availableValuesList.includes(value);
  
		if (element.tagName === 'INPUT') {
		  element.classList.toggle('disabled', !availableElement);
		} else if (element.tagName === 'OPTION') {
		  element.innerText = availableElement
			? value
			: window.variantStrings.unavailable_with_option.replace('[value]', value);
		}
	  });
	}
  
	updatePickupAvailability() {
	  const pickUpAvailability = document.querySelector('pickup-availability');
	  if (!pickUpAvailability) return;
  
	  if (this.currentVariant && this.currentVariant.available) {
		pickUpAvailability.fetchAvailability(this.currentVariant.id);
	  } else {
		pickUpAvailability.removeAttribute('available');
		pickUpAvailability.innerHTML = '';
	  }
	}
  
	removeErrorMessage() {
	  const section = this.closest('section');
	  if (!section) return;
  
	  const productForm = section.querySelector('product-form');
	  if (productForm) productForm.handleErrorMessage();
	}
  
	updateMedia(html) {
	  const mediaGallerySource = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);
	  const mediaGalleryDestination = html.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);
  
	  const refreshSourceData = () => {
		const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
		const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
		const sourceMap = new Map(mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }]));
		return [mediaGallerySourceItems, sourceSet, sourceMap];
	  };
  
	  if (mediaGallerySource && mediaGalleryDestination) {
		let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
		const mediaGalleryDestinationItems = Array.from(mediaGalleryDestination.querySelectorAll('li[data-media-id]'));
		const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
		let shouldRefresh = false;
  
		// add items from new data not present in DOM
		for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
		  if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
			mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
			shouldRefresh = true;
		  }
		}
  
		// remove items from DOM not present in new data
		for (let i = 0; i < mediaGallerySourceItems.length; i++) {
		  if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
			mediaGallerySourceItems[i].remove();
			shouldRefresh = true;
		  }
		}
  
		// refresh
		if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
  
		// if media galleries don't match, sort to match new data order
		mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
		  const sourceData = sourceMap.get(destinationItem.dataset.mediaId);
  
		  if (sourceData && sourceData.index !== destinationIndex) {
			mediaGallerySource.insertBefore(
			  sourceData.item,
			  mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
			);
  
			// refresh source now that it has been modified
			[mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
		  }
		});
	  }
  
	  if (this.currentVariant.featured_media) {
		document
		  .querySelector(`[id^="MediaGallery-${this.dataset.section}"]`)
		  ?.setActiveMedia?.(`${this.dataset.section}-${this.currentVariant.featured_media.id}`);
	  }
  
	  // update media modal
	  const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
	  const newModalContent = html.querySelector(`product-modal`);
	  if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
	}
  
	renderProductInfo() {
	  const requestedVariantId = this.currentVariant.id;
	  const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
  
	  fetch(
		`${this.dataset.url}?variant=${requestedVariantId}&section_id=${
		  this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
		}`
	  )
		.then((response) => response.text())
		.then((responseText) => {
		  // prevent unnecessary ui changes from abandoned selections
		  if (this.currentVariant.id !== requestedVariantId) return;
  
		  const html = new DOMParser().parseFromString(responseText, 'text/html');
		  const destination = document.getElementById(`price-${this.dataset.section}`);
		  const source = html.getElementById(
			`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
		  );
		  const skuSource = html.getElementById(
			`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
		  );
		  const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
		  const inventorySource = html.getElementById(
			`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
		  );
		  const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
  
		  const volumePricingSource = html.getElementById(
			`Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
		  );
  
		  this.updateMedia(html);
  
		  const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
		  const pricePerItemSource = html.getElementById(
			`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
		  );
  
		  const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
		  const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
		  const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
  
		  if (volumeNote) volumeNote.classList.remove('hidden');
		  if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
		  if (qtyRules) qtyRules.classList.remove('hidden');
  
		  if (source && destination) destination.innerHTML = source.innerHTML;
		  if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
		  if (skuSource && skuDestination) {
			skuDestination.innerHTML = skuSource.innerHTML;
			skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
		  }
  
		  if (volumePricingSource && volumePricingDestination) {
			volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
		  }
  
		  if (pricePerItemSource && pricePerItemDestination) {
			pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
			pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
		  }
  
		  const price = document.getElementById(`price-${this.dataset.section}`);
  
		  if (price) price.classList.remove('hidden');
  
		  if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');
  
		  const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
		  this.toggleAddButton(
			addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
			window.variantStrings.soldOut
		  );
  
		  publish(PUB_SUB_EVENTS.variantChange, {
			data: {
			  sectionId,
			  html,
			  variant: this.currentVariant,
			},
		  });
		});
	}
  
	toggleAddButton(disable = true, text, modifyClass = true) {
	  const productForm = document.getElementById(`product-form-${this.dataset.section}`);
	  if (!productForm) return;
	  const addButton = productForm.querySelector('[name="add"]');
	  const addButtonText = productForm.querySelector('[name="add"] > span');
	  if (!addButton) return;
  
	  if (disable) {
		addButton.setAttribute('disabled', 'disabled');
		if (text) addButtonText.textContent = text;
	  } else {
		addButton.removeAttribute('disabled');
		addButtonText.textContent = window.variantStrings.addToCart;
	  }
  
	  if (!modifyClass) return;
	}
  
	setUnavailable() {
	  const button = document.getElementById(`product-form-${this.dataset.section}`);
	  const addButton = button.querySelector('[name="add"]');
	  const addButtonText = button.querySelector('[name="add"] > span');
	  const price = document.getElementById(`price-${this.dataset.section}`);
	  const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
	  const sku = document.getElementById(`Sku-${this.dataset.section}`);
	  const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
	  const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
	  const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
	  const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
  
	  if (!addButton) return;
	  addButtonText.textContent = window.variantStrings.unavailable;
	  if (price) price.classList.add('hidden');
	  if (inventory) inventory.classList.add('hidden');
	  if (sku) sku.classList.add('hidden');
	  if (pricePerItem) pricePerItem.classList.add('hidden');
	  if (volumeNote) volumeNote.classList.add('hidden');
	  if (volumeTable) volumeTable.classList.add('hidden');
	  if (qtyRules) qtyRules.classList.add('hidden');
	}
  
	getVariantData() {
	  this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
	  return this.variantData;
	}
  }
  
  customElements.define('variant-selects', VariantSelects);
  
  class ProductRecommendations extends HTMLElement {
	constructor() {
	  super();
	}
  
	connectedCallback() {
	  const handleIntersection = (entries, observer) => {
		if (!entries[0].isIntersecting) return;
		observer.unobserve(this);
  
		fetch(this.dataset.url)
		  .then((response) => response.text())
		  .then((text) => {
			const html = document.createElement('div');
			html.innerHTML = text;
			const recommendations = html.querySelector('product-recommendations');
  
			if (recommendations && recommendations.innerHTML.trim().length) {
			  this.innerHTML = recommendations.innerHTML;
			}
  
			if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
			  this.remove();
			}
  
			if (html.querySelector('.grid__item')) {
			  this.classList.add('product-recommendations--loaded');
			}
		  })
		  .catch((e) => {
			console.error(e);
		  });
	  };
  
	  new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
	}
  }
  
  customElements.define('product-recommendations', ProductRecommendations);
  
  class AccountIcon extends HTMLElement {
	constructor() {
	  super();
  
	  this.icon = this.querySelector('.icon');
	}
  
	connectedCallback() {
	  document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
	}
  
	handleStorefrontSignInCompleted(event) {
	  if (event?.detail?.avatar) {
		this.icon?.replaceWith(event.detail.avatar.cloneNode());
	  }
	}
  }
  
  customElements.define('account-icon', AccountIcon);
  
